// import { useEffect, useState, useCallback } from "react";

// const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000/api";

// // ── Config ────────────────────────────────────────────────────────────────────
// const TYPE_CFG = {
//   booking:   { icon: "📄", label: "Tax Invoice",      color: "#c9a96e", bg: "rgba(201,169,110,0.12)" },
//   milestone: { icon: "🧾", label: "Payment Receipt",  color: "#22c55e", bg: "rgba(34,197,94,0.12)"   },
// };
// const STATUS_CFG = {
//   issued:    { color: "#22c55e", label: "Issued"    },
//   cancelled: { color: "#ef4444", label: "Cancelled" },
//   revised:   { color: "#f59e0b", label: "Revised"   },
// };

// // ── Invoice Preview Modal ─────────────────────────────────────────────────────
// function InvoicePreviewModal({ invoiceId, token, onClose }) {
//   const [html,    setHtml]    = useState("");
//   const [loading, setLoading] = useState(true);
//   const [sending, setSending] = useState(false);
//   const [sent,    setSent]    = useState(false);

//   useEffect(() => {
//     if (!invoiceId) return;
//     fetch(`${API_BASE}/invoices/${invoiceId}/html`, {
//       headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
//     })
//       .then((r) => r.json())
//       .then((d) => { setHtml(d.html || ""); setLoading(false); })
//       .catch(() => setLoading(false));

//     const esc = (e) => { if (e.key === "Escape") onClose(); };
//     window.addEventListener("keydown", esc);
//     return () => window.removeEventListener("keydown", esc);
//   }, [invoiceId]);

//   const handleResend = async () => {
//     setSending(true);
//     try {
//       await fetch(`${API_BASE}/invoices/${invoiceId}/resend`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
//       });
//       setSent(true);
//       setTimeout(() => setSent(false), 3000);
//     } catch (_) {}
//     setSending(false);
//   };

//   const handlePrint = () => {
//     const frame = document.getElementById("inv-frame");
//     if (frame) { frame.contentWindow.focus(); frame.contentWindow.print(); }
//   };

//   return (
//     <div onClick={onClose} style={{
//       position: "fixed", inset: 0, zIndex: 2000,
//       background: "rgba(0,0,0,0.82)", backdropFilter: "blur(8px)",
//       display: "flex", alignItems: "center", justifyContent: "center", padding: "16px",
//     }}>
//       <div onClick={(e) => e.stopPropagation()} style={{
//         background: "#fff", borderRadius: "14px", width: "100%", maxWidth: "880px",
//         height: "90vh", display: "flex", flexDirection: "column",
//         boxShadow: "0 24px 80px rgba(0,0,0,0.5)", overflow: "hidden",
//       }}>
//         {/* Toolbar */}
//         <div style={{
//           display: "flex", alignItems: "center", justifyContent: "space-between",
//           padding: "12px 20px", background: "#1a1a2e",
//           borderBottom: "1px solid rgba(255,255,255,0.1)", flexShrink: 0,
//         }}>
//           <div style={{ fontSize: "14px", fontWeight: "700", color: "#c9a96e" }}>📄 Invoice Preview</div>
//           <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
//             {sent && <span style={{ fontSize: "12px", color: "#22c55e", fontWeight: "600" }}>✓ Sent!</span>}
//             <button onClick={handleResend} disabled={sending} style={{
//               padding: "7px 16px", borderRadius: "7px", cursor: sending ? "not-allowed" : "pointer",
//               fontSize: "12px", fontWeight: "700",
//               background: "rgba(201,169,110,0.2)", color: "#c9a96e",
//               border: "1px solid rgba(201,169,110,0.35)", opacity: sending ? 0.6 : 1,
//             }}>
//               {sending ? "Sending…" : "📧 Resend Email"}
//             </button>
//             <button onClick={handlePrint} style={{
//               padding: "7px 16px", borderRadius: "7px", cursor: "pointer",
//               fontSize: "12px", fontWeight: "700",
//               background: "linear-gradient(135deg,#c9a96e,#a07840)", color: "#fff", border: "none",
//             }}>🖨 Print / PDF</button>
//             <button onClick={onClose} style={{
//               background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)",
//               color: "#fff", width: "32px", height: "32px", borderRadius: "8px",
//               cursor: "pointer", fontSize: "16px", display: "flex",
//               alignItems: "center", justifyContent: "center",
//             }}>×</button>
//           </div>
//         </div>

//         {/* Invoice iframe */}
//         <div style={{ flex: 1, overflow: "hidden", background: "#f4f4f4" }}>
//           {loading ? (
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "center",
//                           height: "100%", color: "#64748b", flexDirection: "column", gap: "10px" }}>
//               <div style={{ fontSize: "32px" }}>⏳</div>
//               <div>Loading invoice…</div>
//             </div>
//           ) : (
//             <iframe
//               id="inv-frame"
//               srcDoc={html}
//               style={{ width: "100%", height: "100%", border: "none" }}
//               title="Invoice"
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Invoice Card ──────────────────────────────────────────────────────────────
// function InvoiceCard({ invoice, onView }) {
//   const type   = TYPE_CFG[invoice.type]     || TYPE_CFG.booking;
//   const status = STATUS_CFG[invoice.status] || STATUS_CFG.issued;

//   // Build currency formatter from invoice snapshot
//   const sym    = invoice.currency_symbol   || "₹";
//   const pos    = invoice.currency_symbol_position || "before";
//   const dec    = invoice.currency_decimals ?? 2;
//   const locale = invoice.number_format_locale || "en-IN";

//   const f = (n) => {
//     if (n == null) return "—";
//     const formatted = new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec, maximumFractionDigits: dec,
//     }).format(parseFloat(n));
//     return pos === "after" ? `${formatted} ${sym}` : `${sym}${formatted}`;
//   };

//   const labels = invoice.fee_labels || {};
//   const fees = [
//     invoice.processing_fee   > 0 && { label: labels.processing   || "Processing",   val: invoice.processing_fee   },
//     invoice.stamp_duty        > 0 && { label: labels.stamp_duty   || "Stamp Duty",   val: invoice.stamp_duty       },
//     invoice.registration_fee  > 0 && { label: labels.registration || "Reg Fee",      val: invoice.registration_fee },
//     invoice.maintenance_charge> 0 && { label: labels.maintenance  || "Maintenance",  val: invoice.maintenance_charge},
//     invoice.custom_fee1       > 0 && { label: labels.custom1      || "Custom 1",     val: invoice.custom_fee1      },
//     invoice.custom_fee2       > 0 && { label: labels.custom2      || "Custom 2",     val: invoice.custom_fee2      },
//     invoice.tax_amount        > 0 && { label: labels.tax          || invoice.tax_label || "Tax", val: invoice.tax_amount },
//   ].filter(Boolean);

//   return (
//     <div
//       onClick={() => onView(invoice.id)}
//       style={{
//         background: "rgba(255,255,255,0.03)",
//         border: "1px solid rgba(255,255,255,0.07)",
//         borderRadius: "14px", padding: "18px 20px",
//         cursor: "pointer", transition: "border-color 0.2s",
//       }}
//       onMouseEnter={(e) => (e.currentTarget.style.borderColor = "rgba(201,169,110,0.25)")}
//       onMouseLeave={(e) => (e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)")}
//     >
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px", flexWrap: "wrap" }}>
//         <div style={{ flex: 1 }}>
//           {/* Header row */}
//           <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", marginBottom: "6px" }}>
//             <span style={{
//               padding: "2px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: "700",
//               background: type.bg, color: type.color, border: `1px solid ${type.color}33`,
//             }}>
//               {type.icon} {type.label}
//             </span>
//             <span style={{ fontSize: "15px", fontWeight: "800", color: "#e2e8f0" }}>
//               #{invoice.invoice_number}
//             </span>
//             <span style={{ fontSize: "11px", fontWeight: "700", color: status.color }}>
//               {status.label}
//             </span>
//           </div>

//           {/* Unit */}
//           <div style={{ fontSize: "13px", color: "#94a3b8", marginBottom: "3px" }}>
//             🏠 Unit {invoice.plot_number}
//             {invoice.plot_type  && ` · ${invoice.plot_type}`}
//             {invoice.area       && ` · ${invoice.area} ${invoice.area_unit || ''}`}
//             {invoice.project_name && ` · ${invoice.project_name}`}
//           </div>

//           {/* Milestone label for receipts */}
//           {invoice.type === "milestone" && invoice.meta?.milestone_label && (
//             <div style={{ fontSize: "12px", color: "#22c55e", fontWeight: "600" }}>
//               💳 {invoice.meta.milestone_label}
//             </div>
//           )}

//           {/* Date + booking */}
//           <div style={{ fontSize: "11px", color: "#475569", marginTop: "4px" }}>
//             Booking #{invoice.booking_id} ·{" "}
//             {new Date(invoice.issued_at).toLocaleDateString("en-IN", {
//               day: "numeric", month: "short", year: "numeric",
//             })}
//             {invoice.email_sent_at && (
//               <span style={{ marginLeft: "10px", color: "#22c55e" }}>
//                 ✉ Sent {new Date(invoice.email_sent_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
//                 {invoice.broker_copy_sent && " + broker copy"}
//               </span>
//             )}
//           </div>

//           {/* Fee pills */}
//           {fees.length > 0 && (
//             <div style={{ display: "flex", gap: "5px", flexWrap: "wrap", marginTop: "8px" }}>
//               {fees.map((fee, i) => (
//                 <span key={i} style={{
//                   fontSize: "10px", fontWeight: "600",
//                   padding: "2px 8px", borderRadius: "10px",
//                   background: "rgba(255,255,255,0.05)",
//                   color: "#94a3b8",
//                   border: "1px solid rgba(255,255,255,0.08)",
//                 }}>
//                   {fee.label}: {f(fee.val)}
//                 </span>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Amounts */}
//         <div style={{ textAlign: "right", flexShrink: 0 }}>
//           <div style={{ fontSize: "11px", color: "#475569", marginBottom: "2px" }}>
//             {invoice.type === "milestone" ? "Received" : "Amount Paid"}
//           </div>
//           <div style={{ fontSize: "22px", fontWeight: "800", color: "#c9a96e" }}>
//             {f(invoice.amount_paid)}
//           </div>
//           {invoice.total_amount > invoice.amount_paid && (
//             <div style={{ fontSize: "11px", color: "#64748b", marginTop: "1px" }}>
//               of {f(invoice.total_amount)}
//             </div>
//           )}
//           {invoice.balance_due > 0 ? (
//             <div style={{ fontSize: "12px", color: "#f59e0b", marginTop: "3px", fontWeight: "600" }}>
//               Due: {f(invoice.balance_due)}
//             </div>
//           ) : invoice.type !== "milestone" && (
//             <div style={{ fontSize: "11px", color: "#22c55e", marginTop: "3px" }}>✓ Fully Paid</div>
//           )}
//         </div>
//       </div>

//       <div style={{ marginTop: "10px", fontSize: "11px", color: "#c9a96e", fontWeight: "600" }}>
//         🔍 Tap to view & print invoice →
//       </div>
//     </div>
//   );
// }

// // ── Main InvoicesTab ──────────────────────────────────────────────────────────
// export default function InvoicesTab({ user, fmt }) {
//   const [invoices,  setInvoices]  = useState([]);
//   const [loading,   setLoading]   = useState(true);
//   const [filter,    setFilter]    = useState("all");
//   const [previewId, setPreviewId] = useState(null);

//   const fetchInvoices = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res  = await fetch(`${API_BASE}/invoices`, {
//         headers: { Authorization: `Bearer ${user.token}`, Accept: "application/json" },
//       });
//       const data = await res.json();
//       setInvoices(Array.isArray(data) ? data : []);
//     } catch (_) {}
//     setLoading(false);
//   }, [user.token]);

//   useEffect(() => { fetchInvoices(); }, [fetchInvoices]);

//   const filtered = filter === "all" ? invoices : invoices.filter((i) => i.type === filter);

//   // Stats using the invoice's own currency snapshot
//   const sym = invoices[0]?.currency_symbol || "₹";
//   const locale = invoices[0]?.number_format_locale || "en-IN";
//   const dec  = invoices[0]?.currency_decimals ?? 2;
//   const fStat = (n) => sym + new Intl.NumberFormat(locale, { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(n);

//   const totalPaid  = invoices.filter((i) => i.status === "issued").reduce((s, i) => s + parseFloat(i.amount_paid || 0), 0);
//   const totalDue   = invoices.filter((i) => i.status === "issued" && i.type !== "booking").reduce((s, i) => s + parseFloat(i.balance_due || 0), 0);

//   if (loading) return (
//     <div style={{ textAlign: "center", padding: "60px 0", color: "#475569" }}>
//       <div style={{ fontSize: "32px", marginBottom: "10px" }}>⏳</div>
//       Loading invoices…
//     </div>
//   );

//   return (
//     <div>
//       {previewId && (
//         <InvoicePreviewModal
//           invoiceId={previewId}
//           token={user.token}
//           onClose={() => setPreviewId(null)}
//         />
//       )}

//       {/* Stats */}
//       {invoices.length > 0 && (
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: "10px", marginBottom: "20px" }}>
//           {[
//             { label: "Total Invoices", value: invoices.length,    icon: "📄", color: "#c9a96e" },
//             { label: "Total Paid",     value: fStat(totalPaid),   icon: "💰", color: "#22c55e" },
//             { label: "Balance Due",    value: fStat(totalDue),    icon: "⏳", color: totalDue > 0 ? "#f59e0b" : "#22c55e" },
//           ].map(({ label, value, icon, color }) => (
//             <div key={label} style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "12px", padding: "14px 16px" }}>
//               <div style={{ fontSize: "20px", marginBottom: "6px" }}>{icon}</div>
//               <div style={{ fontSize: "18px", fontWeight: "800", color }}>{value}</div>
//               <div style={{ fontSize: "11px", color: "#475569", marginTop: "2px" }}>{label}</div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Filter tabs */}
//       <div style={{ display: "flex", gap: "4px", marginBottom: "16px", background: "rgba(255,255,255,0.03)", padding: "4px", borderRadius: "8px", width: "fit-content" }}>
//         {[["all","All"],["booking","Tax Invoices"],["milestone","Receipts"]].map(([val, label]) => (
//           <button key={val} onClick={() => setFilter(val)} style={{
//             padding: "5px 14px", borderRadius: "6px", cursor: "pointer",
//             fontSize: "12px", fontWeight: "600",
//             background: filter === val ? "rgba(201,169,110,0.15)" : "transparent",
//             color:      filter === val ? "#c9a96e" : "#64748b",
//             border:     filter === val ? "1px solid rgba(201,169,110,0.25)" : "1px solid transparent",
//           }}>{label}</button>
//         ))}
//       </div>

//       {/* Empty */}
//       {filtered.length === 0 && (
//         <div style={{ textAlign: "center", padding: "60px 0" }}>
//           <div style={{ fontSize: "48px", marginBottom: "10px" }}>📄</div>
//           <div style={{ fontSize: "15px", fontWeight: "600", color: "#e2e8f0", marginBottom: "6px" }}>
//             No invoices yet
//           </div>
//           <div style={{ fontSize: "13px", color: "#475569" }}>
//             Invoices are auto-generated when a booking is confirmed and for each milestone payment.
//           </div>
//         </div>
//       )}

//       {/* List */}
//       <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//         {filtered.map((inv) => (
//           <InvoiceCard key={inv.id} invoice={inv} onView={setPreviewId} />
//         ))}
//       </div>
//     </div>
//   );
// }

// import { useEffect, useState, useCallback } from "react";

// import { apiUrl, imgUrl } from "../apiUrl";

// const API_BASE = `${apiUrl}/api`;

// const TYPE_CFG = {
//   booking: {
//     icon: "📄",
//     label: "Tax Invoice",
//     color: "#c9a96e",
//     bg: "rgba(201,169,110,0.12)",
//   },
//   milestone: {
//     icon: "🧾",
//     label: "Payment Receipt",
//     color: "#22c55e",
//     bg: "rgba(34,197,94,0.12)",
//   },
// };
// const STATUS_CFG = {
//   issued: { color: "#22c55e", label: "Issued" },
//   cancelled: { color: "#ef4444", label: "Cancelled" },
//   revised: { color: "#f59e0b", label: "Revised" },
// };

// function InvoicePreviewModal({ invoiceId, token, onClose }) {
//   const [html, setHtml] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [sending, setSending] = useState(false);
//   const [sent, setSent] = useState(false);

//   useEffect(() => {
//     if (!invoiceId) return;
//     fetch(`${API_BASE}/invoices/${invoiceId}/html`, {
//       headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
//     })
//       .then((r) => r.json())
//       .then((d) => {
//         setHtml(d.html || "");
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));

//     const esc = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", esc);
//     return () => window.removeEventListener("keydown", esc);
//   }, [invoiceId]);

//   const handleResend = async () => {
//     setSending(true);
//     try {
//       await fetch(`${API_BASE}/invoices/${invoiceId}/resend`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       });
//       setSent(true);
//       setTimeout(() => setSent(false), 3000);
//     } catch (_) {}
//     setSending(false);
//   };

//   const handlePrint = () => {
//     const frame = document.getElementById("inv-frame");
//     if (frame) {
//       frame.contentWindow.focus();
//       frame.contentWindow.print();
//     }
//   };

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         zIndex: 2000,
//         background: "rgba(0,0,0,0.82)",
//         backdropFilter: "blur(8px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "16px",
//       }}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           background: "#fff",
//           borderRadius: "14px",
//           width: "100%",
//           maxWidth: "880px",
//           height: "90vh",
//           display: "flex",
//           flexDirection: "column",
//           boxShadow: "0 24px 80px rgba(0,0,0,0.5)",
//           overflow: "hidden",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             padding: "12px 20px",
//             background: "#1a1a2e",
//             borderBottom: "1px solid rgba(255,255,255,0.1)",
//             flexShrink: 0,
//           }}
//         >
//           <div
//             style={{ fontSize: "14px", fontWeight: "700", color: "#c9a96e" }}
//           >
//             📄 Invoice Preview
//           </div>
//           <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
//             {sent && (
//               <span
//                 style={{
//                   fontSize: "12px",
//                   color: "#22c55e",
//                   fontWeight: "600",
//                 }}
//               >
//                 ✓ Sent!
//               </span>
//             )}
//             <button
//               onClick={handleResend}
//               disabled={sending}
//               style={{
//                 padding: "7px 16px",
//                 borderRadius: "7px",
//                 cursor: sending ? "not-allowed" : "pointer",
//                 fontSize: "12px",
//                 fontWeight: "700",
//                 background: "rgba(201,169,110,0.2)",
//                 color: "#c9a96e",
//                 border: "1px solid rgba(201,169,110,0.35)",
//                 opacity: sending ? 0.6 : 1,
//               }}
//             >
//               {sending ? "Sending…" : "📧 Resend Email"}
//             </button>
//             <button
//               onClick={handlePrint}
//               style={{
//                 padding: "7px 16px",
//                 borderRadius: "7px",
//                 cursor: "pointer",
//                 fontSize: "12px",
//                 fontWeight: "700",
//                 background: "linear-gradient(135deg,#c9a96e,#a07840)",
//                 color: "#fff",
//                 border: "none",
//               }}
//             >
//               🖨 Print / PDF
//             </button>
//             <button
//               onClick={onClose}
//               style={{
//                 background: "rgba(255,255,255,0.1)",
//                 border: "1px solid rgba(255,255,255,0.15)",
//                 color: "#fff",
//                 width: "32px",
//                 height: "32px",
//                 borderRadius: "8px",
//                 cursor: "pointer",
//                 fontSize: "16px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               ×
//             </button>
//           </div>
//         </div>
//         <div style={{ flex: 1, overflow: "hidden", background: "#f4f4f4" }}>
//           {loading ? (
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 height: "100%",
//                 color: "#64748b",
//                 flexDirection: "column",
//                 gap: "10px",
//               }}
//             >
//               <div style={{ fontSize: "32px" }}>⏳</div>
//               <div>Loading invoice…</div>
//             </div>
//           ) : (
//             <iframe
//               id="inv-frame"
//               srcDoc={html}
//               style={{ width: "100%", height: "100%", border: "none" }}
//               title="Invoice"
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// function InvoiceCard({ invoice, onView }) {
//   const type = TYPE_CFG[invoice.type] || TYPE_CFG.booking;
//   const status = STATUS_CFG[invoice.status] || STATUS_CFG.issued;

//   const sym = invoice.currency_symbol || "₹";
//   const pos = invoice.currency_symbol_position || "before";
//   const dec = invoice.currency_decimals ?? 2;
//   const locale = invoice.number_format_locale || "en-IN";

//   const f = (n) => {
//     if (n == null) return "—";
//     const formatted = new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec,
//       maximumFractionDigits: dec,
//     }).format(parseFloat(n));
//     return pos === "after" ? `${formatted} ${sym}` : `${sym}${formatted}`;
//   };

//   const labels = invoice.fee_labels || {};
//   const fees = [
//     invoice.processing_fee > 0 && {
//       label: labels.processing || "Processing",
//       val: invoice.processing_fee,
//     },
//     invoice.stamp_duty > 0 && {
//       label: labels.stamp_duty || "Stamp Duty",
//       val: invoice.stamp_duty,
//     },
//     invoice.registration_fee > 0 && {
//       label: labels.registration || "Reg Fee",
//       val: invoice.registration_fee,
//     },
//     invoice.maintenance_charge > 0 && {
//       label: labels.maintenance || "Maintenance",
//       val: invoice.maintenance_charge,
//     },
//     invoice.custom_fee1 > 0 && {
//       label: labels.custom1 || "Custom 1",
//       val: invoice.custom_fee1,
//     },
//     invoice.custom_fee2 > 0 && {
//       label: labels.custom2 || "Custom 2",
//       val: invoice.custom_fee2,
//     },
//     invoice.tax_amount > 0 && {
//       label: labels.tax || invoice.tax_label || "Tax",
//       val: invoice.tax_amount,
//     },
//   ].filter(Boolean);

//   return (
//     <div
//       onClick={() => onView(invoice.id)}
//       style={{
//         background: "rgba(255,255,255,0.03)",
//         border: "1px solid rgba(255,255,255,0.07)",
//         borderRadius: "14px",
//         padding: "18px 20px",
//         cursor: "pointer",
//         transition: "border-color 0.2s",
//       }}
//       onMouseEnter={(e) =>
//         (e.currentTarget.style.borderColor = "rgba(201,169,110,0.25)")
//       }
//       onMouseLeave={(e) =>
//         (e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)")
//       }
//     >
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "flex-start",
//           gap: "12px",
//           flexWrap: "wrap",
//         }}
//       >
//         <div style={{ flex: 1 }}>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//               flexWrap: "wrap",
//               marginBottom: "6px",
//             }}
//           >
//             <span
//               style={{
//                 padding: "2px 10px",
//                 borderRadius: "20px",
//                 fontSize: "11px",
//                 fontWeight: "700",
//                 background: type.bg,
//                 color: type.color,
//                 border: `1px solid ${type.color}33`,
//               }}
//             >
//               {type.icon} {type.label}
//             </span>
//             <span
//               style={{ fontSize: "15px", fontWeight: "800", color: "#e2e8f0" }}
//             >
//               #{invoice.invoice_number}
//             </span>
//             <span
//               style={{
//                 fontSize: "11px",
//                 fontWeight: "700",
//                 color: status.color,
//               }}
//             >
//               {status.label}
//             </span>
//           </div>

//           <div
//             style={{ fontSize: "13px", color: "#94a3b8", marginBottom: "3px" }}
//           >
//             🏠 Unit {invoice.plot_number}
//             {invoice.plot_type && ` · ${invoice.plot_type}`}
//             {invoice.area && ` · ${invoice.area} ${invoice.area_unit || ""}`}
//             {invoice.project_name && ` · ${invoice.project_name}`}
//           </div>

//           {invoice.type === "milestone" && invoice.meta?.milestone_label && (
//             <div
//               style={{ fontSize: "12px", color: "#22c55e", fontWeight: "600" }}
//             >
//               💳 {invoice.meta.milestone_label}
//             </div>
//           )}

//           <div style={{ fontSize: "11px", color: "#475569", marginTop: "4px" }}>
//             Booking #{invoice.booking_id} ·{" "}
//             {new Date(invoice.issued_at).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//               year: "numeric",
//             })}
//             {invoice.email_sent_at && (
//               <span style={{ marginLeft: "10px", color: "#22c55e" }}>
//                 ✉ Sent{" "}
//                 {new Date(invoice.email_sent_at).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "short",
//                 })}
//                 {invoice.broker_copy_sent && " + broker copy"}
//               </span>
//             )}
//           </div>

//           {fees.length > 0 && (
//             <div
//               style={{
//                 display: "flex",
//                 gap: "5px",
//                 flexWrap: "wrap",
//                 marginTop: "8px",
//               }}
//             >
//               {fees.map((fee, i) => (
//                 <span
//                   key={i}
//                   style={{
//                     fontSize: "10px",
//                     fontWeight: "600",
//                     padding: "2px 8px",
//                     borderRadius: "10px",
//                     background: "rgba(255,255,255,0.05)",
//                     color: "#94a3b8",
//                     border: "1px solid rgba(255,255,255,0.08)",
//                   }}
//                 >
//                   {fee.label}: {f(fee.val)}
//                 </span>
//               ))}
//             </div>
//           )}
//         </div>

//         <div style={{ textAlign: "right", flexShrink: 0 }}>
//           <div
//             style={{ fontSize: "11px", color: "#475569", marginBottom: "2px" }}
//           >
//             {invoice.type === "milestone" ? "Received" : "Amount Paid"}
//           </div>
//           <div
//             style={{ fontSize: "22px", fontWeight: "800", color: "#c9a96e" }}
//           >
//             {f(invoice.amount_paid)}
//           </div>
//           {parseFloat(invoice.total_amount) >
//             parseFloat(invoice.amount_paid) && (
//             <div
//               style={{ fontSize: "11px", color: "#64748b", marginTop: "1px" }}
//             >
//               of {f(invoice.total_amount)}
//             </div>
//           )}
//           {parseFloat(invoice.balance_due) > 0 ? (
//             <div
//               style={{
//                 fontSize: "12px",
//                 color: "#f59e0b",
//                 marginTop: "3px",
//                 fontWeight: "600",
//               }}
//             >
//               Due: {f(invoice.balance_due)}
//             </div>
//           ) : (
//             invoice.type !== "milestone" && (
//               <div
//                 style={{ fontSize: "11px", color: "#22c55e", marginTop: "3px" }}
//               >
//                 ✓ Fully Paid
//               </div>
//             )
//           )}
//         </div>
//       </div>

//       <div
//         style={{
//           marginTop: "10px",
//           fontSize: "11px",
//           color: "#c9a96e",
//           fontWeight: "600",
//         }}
//       >
//         🔍 Tap to view & print invoice →
//       </div>
//     </div>
//   );
// }

// export default function InvoicesTab({ user, fmt }) {

//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState("all");
//   const [previewId, setPreviewId] = useState(null);

//   const fetchInvoices = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`${API_BASE}/invoices`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const data = await res.json();
//       setInvoices(Array.isArray(data) ? data : []);
//     } catch (_) {}
//     setLoading(false);
//   }, [user.token]);

//   useEffect(() => {
//     fetchInvoices();
//   }, [fetchInvoices]);

//     if (!user) return null;

//   const filtered =
//     filter === "all" ? invoices : invoices.filter((i) => i.type === filter);

//   const sym = invoices[0]?.currency_symbol || "₹";
//   const locale = invoices[0]?.number_format_locale || "en-IN";
//   const dec = invoices[0]?.currency_decimals ?? 2;
//   const fStat = (n) =>
//     sym +
//     new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec,
//       maximumFractionDigits: dec,
//     }).format(n);

//   // FIX: Use booking invoices only as the source of truth for money stats.
//   // Milestone receipts record per-payment amounts that are already reflected
//   // in the booking invoice's amount_paid — summing both would double-count.
//   // const bookingInvoices = invoices.filter((i) => i.status === "issued" && i.type === "booking");
//   // const totalPaid = bookingInvoices.reduce((s, i) => s + parseFloat(i.amount_paid  || 0), 0);
//   // const totalDue  = bookingInvoices.reduce((s, i) => s + parseFloat(i.balance_due  || 0), 0);

//   // Group milestone receipts by booking_id to get real paid amounts
//   const milestonesByBooking = invoices
//     .filter((i) => i.status === "issued" && i.type === "milestone")
//     .reduce((acc, i) => {
//       const bid = i.booking_id;
//       acc[bid] = (acc[bid] || 0) + parseFloat(i.amount_paid || 0);
//       return acc;
//     }, {});

//   // Booking invoices give us total_amount per booking
//   const bookingInvoices = invoices.filter(
//     (i) => i.status === "issued" && i.type === "booking",
//   );

//   const totalPaid = bookingInvoices.reduce((s, i) => {
//     // Prefer sum of milestone receipts if any exist, else fall back to booking invoice amount_paid
//     const milestonePaid = milestonesByBooking[i.booking_id];
//     return (
//       s +
//       (milestonePaid != null ? milestonePaid : parseFloat(i.amount_paid || 0))
//     );
//   }, 0);

//   const totalDue = bookingInvoices.reduce((s, i) => {
//     const total = parseFloat(i.total_amount || 0);
//     const milestonePaid = milestonesByBooking[i.booking_id];
//     const paid =
//       milestonePaid != null ? milestonePaid : parseFloat(i.amount_paid || 0);
//     return s + Math.max(0, total - paid);
//   }, 0);

//   if (loading)
//     return (
//       <div style={{ textAlign: "center", padding: "60px 0", color: "#475569" }}>
//         <div style={{ fontSize: "32px", marginBottom: "10px" }}>⏳</div>
//         Loading invoices…
//       </div>
//     );

//   return (
//     <div>
//       {previewId && (
//         <InvoicePreviewModal
//           invoiceId={previewId}
//           token={user.token}
//           onClose={() => setPreviewId(null)}
//         />
//       )}

//       {invoices.length > 0 && (
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))",
//             gap: "10px",
//             marginBottom: "20px",
//           }}
//         >
//           {[
//             {
//               label: "Total Invoices",
//               value: invoices.length,
//               icon: "📄",
//               color: "#c9a96e",
//             },
//             {
//               label: "Total Paid",
//               value: fStat(totalPaid),
//               icon: "💰",
//               color: "#22c55e",
//             },
//             {
//               label: "Balance Due",
//               value: fStat(totalDue),
//               icon: "⏳",
//               color: totalDue > 0 ? "#f59e0b" : "#22c55e",
//             },
//           ].map(({ label, value, icon, color }) => (
//             <div
//               key={label}
//               style={{
//                 background: "rgba(255,255,255,0.03)",
//                 border: "1px solid rgba(255,255,255,0.07)",
//                 borderRadius: "12px",
//                 padding: "14px 16px",
//               }}
//             >
//               <div style={{ fontSize: "20px", marginBottom: "6px" }}>
//                 {icon}
//               </div>
//               <div style={{ fontSize: "18px", fontWeight: "800", color }}>
//                 {value}
//               </div>
//               <div
//                 style={{ fontSize: "11px", color: "#475569", marginTop: "2px" }}
//               >
//                 {label}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       <div
//         style={{
//           display: "flex",
//           gap: "4px",
//           marginBottom: "16px",
//           background: "rgba(255,255,255,0.03)",
//           padding: "4px",
//           borderRadius: "8px",
//           width: "fit-content",
//         }}
//       >
//         {[
//           ["all", "All"],
//           ["booking", "Tax Invoices"],
//           ["milestone", "Receipts"],
//         ].map(([val, label]) => (
//           <button
//             key={val}
//             onClick={() => setFilter(val)}
//             style={{
//               padding: "5px 14px",
//               borderRadius: "6px",
//               cursor: "pointer",
//               fontSize: "12px",
//               fontWeight: "600",
//               background:
//                 filter === val ? "rgba(201,169,110,0.15)" : "transparent",
//               color: filter === val ? "#c9a96e" : "#64748b",
//               border:
//                 filter === val
//                   ? "1px solid rgba(201,169,110,0.25)"
//                   : "1px solid transparent",
//             }}
//           >
//             {label}
//           </button>
//         ))}
//       </div>

//       {filtered.length === 0 && (
//         <div style={{ textAlign: "center", padding: "60px 0" }}>
//           <div style={{ fontSize: "48px", marginBottom: "10px" }}>📄</div>
//           <div
//             style={{
//               fontSize: "15px",
//               fontWeight: "600",
//               color: "#e2e8f0",
//               marginBottom: "6px",
//             }}
//           >
//             No invoices yet
//           </div>
//           <div style={{ fontSize: "13px", color: "#475569" }}>
//             Invoices are auto-generated when a booking is confirmed and for each
//             milestone payment.
//           </div>
//         </div>
//       )}

//       <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//         {filtered.map((inv) => (
//           <InvoiceCard key={inv.id} invoice={inv} onView={setPreviewId} />
//         ))}
//       </div>
//     </div>
//   );
// }


// InvoicesTab.jsx - Redesigned with elegant appearance
// import { useEffect, useState, useCallback } from "react";
// import { apiUrl, imgUrl } from "../apiUrl";

// const API_BASE = `${apiUrl}/api`;

// const TYPE_CFG = {
//   booking: {
//     icon: "📄",
//     label: "Tax Invoice",
//     color: "var(--primary-color)",
//     bg: "rgba(var(--primary-rgb), 0.12)",
//   },
//   milestone: {
//     icon: "🧾",
//     label: "Payment Receipt",
//     color: "#22c55e",
//     bg: "rgba(34,197,94,0.12)",
//   },
// };

// const STATUS_CFG = {
//   issued: { color: "#22c55e", label: "Issued" },
//   cancelled: { color: "#ef4444", label: "Cancelled" },
//   revised: { color: "#f59e0b", label: "Revised" },
// };

// // Elegant Modal
// const InvoicePreviewModal = ({ invoiceId, token, onClose }) => {
//   const [html, setHtml] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [sending, setSending] = useState(false);
//   const [sent, setSent] = useState(false);

//   useEffect(() => {
//     if (!invoiceId) return;
//     fetch(`${API_BASE}/invoices/${invoiceId}/html`, {
//       headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
//     })
//       .then((r) => r.json())
//       .then((d) => {
//         setHtml(d.html || "");
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));

//     const esc = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", esc);
//     return () => window.removeEventListener("keydown", esc);
//   }, [invoiceId]);

//   const handleResend = async () => {
//     setSending(true);
//     try {
//       await fetch(`${API_BASE}/invoices/${invoiceId}/resend`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       });
//       setSent(true);
//       setTimeout(() => setSent(false), 3000);
//     } catch (_) { }
//     setSending(false);
//   };

//   const handlePrint = () => {
//     const frame = document.getElementById("inv-frame");
//     if (frame) {
//       frame.contentWindow.focus();
//       frame.contentWindow.print();
//     }
//   };

//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed",
//         inset: 0,
//         zIndex: 2000,
//         background: "rgba(0,0,0,0.8)",
//         backdropFilter: "blur(8px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         padding: "20px",
//       }}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           background: "#fff",
//           // borderRadius: "24px",
//           width: "100%",
//           maxWidth: "900px",
//           height: "90vh",
//           display: "flex",
//           flexDirection: "column",
//           boxShadow: "0 32px 80px rgba(0,0,0,0.3)",
//           overflow: "hidden",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             padding: "16px 24px",
//             background: "#1a1a2e",
//             flexShrink: 0,
//           }}
//         >
//           <div style={{ fontSize: "15px", fontWeight: "700", color: primaryColor }}>
//             📄 Invoice Preview
//           </div>
//           <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
//             {sent && (
//               <span style={{ fontSize: "12px", color: "#22c55e", fontWeight: "600", background: "#22c55e15", padding: "4px 12px", borderRadius: "20px" }}>
//                 ✓ Sent!
//               </span>
//             )}
//             <button
//               onClick={handleResend}
//               disabled={sending}
//               style={{
//                 padding: "8px 18px",
//                 borderRadius: "10px",
//                 cursor: sending ? "not-allowed" : "pointer",
//                 fontSize: "13px",
//                 fontWeight: "600",
//                 background: `${primaryColor}15`,
//                 color: primaryColor,
//                 border: `1px solid ${primaryColor}35`,
//                 transition: "all 0.2s ease",
//               }}
//             >
//               {sending ? "Sending…" : "📧 Resend Email"}
//             </button>
//             <button
//               onClick={handlePrint}
//               style={{
//                 padding: "8px 18px",
//                 borderRadius: "10px",
//                 cursor: "pointer",
//                 fontSize: "13px",
//                 fontWeight: "600",
//                 background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)`,
//                 color: "#fff",
//                 border: "none",
//               }}
//             >
//               🖨 Print / PDF
//             </button>
//             <button
//               onClick={onClose}
//               style={{
//                 background: "rgba(255,255,255,0.1)",
//                 border: "1px solid rgba(255,255,255,0.15)",
//                 color: "#fff",
//                 width: "36px",
//                 height: "36px",
//                 borderRadius: "10px",
//                 cursor: "pointer",
//                 fontSize: "18px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               ×
//             </button>
//           </div>
//         </div>
//         <div style={{ flex: 1, overflow: "hidden", background: "#f4f4f4" }}>
//           {loading ? (
//             <div style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               height: "100%",
//               color: "#64748b",
//               flexDirection: "column",
//               gap: "16px",
//             }}>
//               <div style={{ fontSize: "48px" }}>⏳</div>
//               <div>Loading invoice…</div>
//             </div>
//           ) : (
//             <iframe
//               id="inv-frame"
//               srcDoc={html}
//               style={{ width: "100%", height: "100%", border: "none" }}
//               title="Invoice"
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // Elegant Invoice Card
// const InvoiceCard = ({ invoice, onView }) => {
//   const type = TYPE_CFG[invoice.type] || TYPE_CFG.booking;
//   const status = STATUS_CFG[invoice.status] || STATUS_CFG.issued;
//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   const sym = invoice.currency_symbol || "₹";
//   const pos = invoice.currency_symbol_position || "before";
//   const dec = invoice.currency_decimals ?? 2;
//   const locale = invoice.number_format_locale || "en-IN";

//   const f = (n) => {
//     if (n == null) return "—";
//     const formatted = new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec,
//       maximumFractionDigits: dec,
//     }).format(parseFloat(n));
//     return pos === "after" ? `${formatted} ${sym}` : `${sym}${formatted}`;
//   };

//   const labels = invoice.fee_labels || {};
//   const fees = [
//     invoice.processing_fee > 0 && { label: labels.processing || "Processing", val: invoice.processing_fee },
//     invoice.stamp_duty > 0 && { label: labels.stamp_duty || "Stamp Duty", val: invoice.stamp_duty },
//     invoice.registration_fee > 0 && { label: labels.registration || "Reg Fee", val: invoice.registration_fee },
//     invoice.maintenance_charge > 0 && { label: labels.maintenance || "Maintenance", val: invoice.maintenance_charge },
//     invoice.custom_fee1 > 0 && { label: labels.custom1 || "Custom 1", val: invoice.custom_fee1 },
//     invoice.custom_fee2 > 0 && { label: labels.custom2 || "Custom 2", val: invoice.custom_fee2 },
//     invoice.tax_amount > 0 && { label: labels.tax || invoice.tax_label || "Tax", val: invoice.tax_amount },
//   ].filter(Boolean);

//   return (
//     <div
//       onClick={() => onView(invoice.id)}
//       style={{
//         background: "var(--card-bg)",
//         border: "1px solid var(--card-border)",
//         borderRadius: "20px",
//         padding: "20px",
//         cursor: "pointer",
//         transition: "all 0.3s cubic-bezier(0.2, 0.9, 0.4, 1.1)",
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.borderColor = primaryColor + "40";
//         e.currentTarget.style.transform = "translateY(-2px)";
//         e.currentTarget.style.boxShadow = `0 8px 30px ${primaryColor}10`;
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.borderColor = "var(--card-border)";
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.boxShadow = "none";
//       }}
//     >
//       <div style={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "flex-start",
//         gap: "16px",
//         flexWrap: "wrap",
//       }}>
//         <div style={{ flex: 1 }}>
//           <div style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "10px",
//             flexWrap: "wrap",
//             marginBottom: "10px",
//           }}>
//             <span style={{
//               padding: "4px 12px",
//               borderRadius: "20px",
//               fontSize: "11px",
//               fontWeight: "700",
//               background: type.bg,
//               color: type.color,
//               border: `1px solid ${type.color}33`,
//             }}>
//               {type.icon} {type.label}
//             </span>
//             <span style={{ fontSize: "16px", fontWeight: "800", color: "var(--text-dark)", fontFamily: "var(--font-heading, inherit)" }}>
//               #{invoice.invoice_number}
//             </span>
//             <span style={{
//               fontSize: "11px",
//               fontWeight: "700",
//               color: status.color,
//               padding: "3px 10px",
//               borderRadius: "20px",
//               background: `${status.color}10`,
//             }}>
//               {status.label}
//             </span>
//           </div>

//           <div style={{ fontSize: "13px", color: "var(--text-muted)", marginBottom: "6px" }}>
//             🏠 Unit {invoice.plot_number}
//             {invoice.plot_type && ` · ${invoice.plot_type}`}
//             {invoice.area && ` · ${invoice.area} ${invoice.area_unit || ""}`}
//             {invoice.project_name && ` · ${invoice.project_name}`}
//           </div>

//           {invoice.type === "milestone" && invoice.meta?.milestone_label && (
//             <div style={{ fontSize: "12px", color: "#22c55e", fontWeight: "600", marginBottom: "4px" }}>
//               💳 {invoice.meta.milestone_label}
//             </div>
//           )}

//           <div style={{ fontSize: "11px", color: "var(--text-muted)", marginTop: "6px" }}>
//             Booking #{invoice.booking_id} ·{" "}
//             {new Date(invoice.issued_at).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//               year: "numeric",
//             })}
//             {invoice.email_sent_at && (
//               <span style={{ marginLeft: "12px", color: "#22c55e" }}>
//                 ✉ Sent{" "}
//                 {new Date(invoice.email_sent_at).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "short",
//                 })}
//                 {invoice.broker_copy_sent && " + broker copy"}
//               </span>
//             )}
//           </div>

//           {fees.length > 0 && (
//             <div style={{
//               display: "flex",
//               gap: "8px",
//               flexWrap: "wrap",
//               marginTop: "12px",
//             }}>
//               {fees.map((fee, i) => (
//                 <span
//                   key={i}
//                   style={{
//                     fontSize: "11px",
//                     fontWeight: "600",
//                     padding: "3px 10px",
//                     borderRadius: "12px",
//                     background: "var(--page-bg)",
//                     color: "var(--text-muted)",
//                     border: "1px solid var(--card-border)",
//                   }}
//                 >
//                   {fee.label}: {f(fee.val)}
//                 </span>
//               ))}
//             </div>
//           )}
//         </div>

//         <div style={{ textAlign: "right", flexShrink: 0 }}>
//           <div style={{ fontSize: "11px", color: "var(--text-muted)", marginBottom: "4px" }}>
//             {invoice.type === "milestone" ? "Received" : "Amount Paid"}
//           </div>
//           <div style={{ fontSize: "26px", fontWeight: "800", color: primaryColor, fontFamily: "var(--font-heading, inherit)" }}>
//             {f(invoice.amount_paid)}
//           </div>
//           {parseFloat(invoice.total_amount) > parseFloat(invoice.amount_paid) && (
//             <div style={{ fontSize: "12px", color: "var(--text-muted)", marginTop: "2px" }}>
//               of {f(invoice.total_amount)}
//             </div>
//           )}
//           {parseFloat(invoice.balance_due) > 0 ? (
//             <div style={{
//               fontSize: "13px",
//               color: "#f59e0b",
//               marginTop: "6px",
//               fontWeight: "700",
//             }}>
//               Due: {f(invoice.balance_due)}
//             </div>
//           ) : (
//             invoice.type !== "milestone" && (
//               <div style={{ fontSize: "12px", color: "#22c55e", marginTop: "6px", fontWeight: 600 }}>
//                 ✓ Fully Paid
//               </div>
//             )
//           )}
//         </div>
//       </div>

//       <div style={{
//         marginTop: "16px",
//         fontSize: "12px",
//         color: primaryColor,
//         fontWeight: "600",
//         display: "flex",
//         alignItems: "center",
//         gap: "6px",
//       }}>
//         🔍 Tap to view & print invoice →
//       </div>
//     </div>
//   );
// };

// // Elegant Stat Card for Invoices
// const InvoiceStatCard = ({ icon, label, value, color }) => (
//   <div style={{
//     background: "var(--card-bg)",
//     border: "1px solid var(--card-border)",
//     borderRadius: "16px",
//     padding: "16px 18px",
//     transition: "all 0.2s ease",
//   }}
//   onMouseEnter={(e) => {
//     e.currentTarget.style.borderColor = color;
//     e.currentTarget.style.transform = "translateY(-2px)";
//   }}
//   onMouseLeave={(e) => {
//     e.currentTarget.style.borderColor = "var(--card-border)";
//     e.currentTarget.style.transform = "translateY(0)";
//   }}>
//     <div style={{ fontSize: "28px", marginBottom: "8px" }}>{icon}</div>
//     <div style={{ fontSize: "22px", fontWeight: "800", color }}>{value}</div>
//     <div style={{ fontSize: "12px", color: "var(--text-muted)", marginTop: "4px" }}>{label}</div>
//   </div>
// );

// export default function InvoicesTab({ user, fmt }) {
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState("all");
//   const [previewId, setPreviewId] = useState(null);
//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   const fetchInvoices = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`${API_BASE}/invoices`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const data = await res.json();
//       setInvoices(Array.isArray(data) ? data : []);
//     } catch (_) { }
//     setLoading(false);
//   }, [user.token]);

//   useEffect(() => {
//     fetchInvoices();
//   }, [fetchInvoices]);

//   if (!user) return null;

//   const filtered = filter === "all" ? invoices : invoices.filter((i) => i.type === filter);

//   const sym = invoices[0]?.currency_symbol || "₹";
//   const locale = invoices[0]?.number_format_locale || "en-IN";
//   const dec = invoices[0]?.currency_decimals ?? 2;
//   const fStat = (n) =>
//     sym +
//     new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec,
//       maximumFractionDigits: dec,
//     }).format(n);

//   const milestonesByBooking = invoices
//     .filter((i) => i.status === "issued" && i.type === "milestone")
//     .reduce((acc, i) => {
//       const bid = i.booking_id;
//       acc[bid] = (acc[bid] || 0) + parseFloat(i.amount_paid || 0);
//       return acc;
//     }, {});

//   const bookingInvoices = invoices.filter(
//     (i) => i.status === "issued" && i.type === "booking",
//   );

//   const totalPaid = bookingInvoices.reduce((s, i) => {
//     const milestonePaid = milestonesByBooking[i.booking_id];
//     return s + (milestonePaid != null ? milestonePaid : parseFloat(i.amount_paid || 0));
//   }, 0);

//   const totalDue = bookingInvoices.reduce((s, i) => {
//     const total = parseFloat(i.total_amount || 0);
//     const milestonePaid = milestonesByBooking[i.booking_id];
//     const paid = milestonePaid != null ? milestonePaid : parseFloat(i.amount_paid || 0);
//     return s + Math.max(0, total - paid);
//   }, 0);

//   if (loading)
//     return (
//       <div style={{ textAlign: "center", padding: "80px 0", color: "var(--text-muted)" }}>
//         <div style={{ fontSize: "48px", marginBottom: "16px" }}>⏳</div>
//         <div>Loading invoices…</div>
//       </div>
//     );

//   return (
//     <div>
//       {previewId && (
//         <InvoicePreviewModal
//           invoiceId={previewId}
//           token={user.token}
//           onClose={() => setPreviewId(null)}
//         />
//       )}

//       {invoices.length > 0 && (
//         <div style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
//           gap: "12px",
//           marginBottom: "28px",
//         }}>
//           <InvoiceStatCard label="Total Invoices" value={invoices.length} icon="📄" color={primaryColor} />
//           <InvoiceStatCard label="Total Paid" value={fStat(totalPaid)} icon="💰" color="#22c55e" />
//           <InvoiceStatCard label="Balance Due" value={fStat(totalDue)} icon="⏳" color={totalDue > 0 ? "#f59e0b" : "#22c55e"} />
//         </div>
//       )}

//       <div style={{
//         display: "flex",
//         gap: "6px",
//         marginBottom: "24px",
//         background: "var(--card-bg)",
//         padding: "6px",
//         borderRadius: "16px",
//         border: "1px solid var(--card-border)",
//         width: "fit-content",
//       }}>
//         {[
//           ["all", "All"],
//           ["booking", "Tax Invoices"],
//           ["milestone", "Receipts"],
//         ].map(([val, label]) => (
//           <button
//             key={val}
//             onClick={() => setFilter(val)}
//             style={{
//               padding: "8px 20px",
//               borderRadius: "12px",
//               cursor: "pointer",
//               fontSize: "13px",
//               fontWeight: "600",
//               background: filter === val ? `${primaryColor}12` : "transparent",
//               color: filter === val ? primaryColor : "var(--text-muted)",
//               border: filter === val ? `1px solid ${primaryColor}30` : "1px solid transparent",
//               transition: "all 0.2s ease",
//               fontFamily: "var(--font-body, inherit)",
//             }}
//           >
//             {label}
//           </button>
//         ))}
//       </div>

//       {filtered.length === 0 && (
//         <div style={{ textAlign: "center", padding: "80px 0" }}>
//           <div style={{ fontSize: "64px", marginBottom: "16px" }}>📄</div>
//           <div style={{
//             fontSize: "18px",
//             fontWeight: "700",
//             color: "var(--text-dark)",
//             marginBottom: "10px",
//             fontFamily: "var(--font-heading, inherit)",
//           }}>
//             No invoices yet
//           </div>
//           <div style={{ fontSize: "14px", color: "var(--text-muted)" }}>
//             Invoices are auto-generated when a booking is confirmed and for each milestone payment.
//           </div>
//         </div>
//       )}

//       <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
//         {filtered.map((inv) => (
//           <InvoiceCard key={inv.id} invoice={inv} onView={setPreviewId} />
//         ))}
//       </div>
//     </div>
//   );
// }

// InvoicesTab.jsx - Updated with refund/cancellation handling
// import { useEffect, useState, useCallback } from "react";
// import { apiUrl, imgUrl } from "../apiUrl";

// const API_BASE = `${apiUrl}/api`;

// const TYPE_CFG = {
//   booking: {
//     icon: "📄",
//     label: "Tax Invoice",
//     color: "var(--primary-color)",
//     bg: "rgba(var(--primary-rgb), 0.12)",
//   },
//   milestone: {
//     icon: "🧾",
//     label: "Payment Receipt",
//     color: "#22c55e",
//     bg: "rgba(34,197,94,0.12)",
//   },
//   refund: {
//     icon: "↺",
//     label: "Refund Note",
//     color: "#94a3b8",
//     bg: "rgba(148,163,184,0.12)",
//   },
//   cancellation: {
//     icon: "✕",
//     label: "Cancellation",
//     color: "#ef4444",
//     bg: "rgba(239,68,68,0.12)",
//   },
// };

// const STATUS_CFG = {
//   issued: { color: "#22c55e", label: "Issued" },
//   cancelled: { color: "#ef4444", label: "Cancelled" },
//   revised: { color: "#f59e0b", label: "Revised" },
//   refunded: { color: "#94a3b8", label: "Refunded" },
// };

// // Elegant Modal
// const InvoicePreviewModal = ({ invoiceId, token, onClose }) => {
//   const [html, setHtml] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [sending, setSending] = useState(false);
//   const [sent, setSent] = useState(false);

//   useEffect(() => {
//     if (!invoiceId) return;
//     fetch(`${API_BASE}/invoices/${invoiceId}/html`, {
//       headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
//     })
//       .then((r) => r.json())
//       .then((d) => {
//         setHtml(d.html || "");
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));

//     const esc = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", esc);
//     return () => window.removeEventListener("keydown", esc);
//   }, [invoiceId]);

//   const handleResend = async () => {
//     setSending(true);
//     try {
//       await fetch(`${API_BASE}/invoices/${invoiceId}/resend`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       });
//       setSent(true);
//       setTimeout(() => setSent(false), 3000);
//     } catch (_) { }
//     setSending(false);
//   };

//   const handlePrint = () => {
//     const frame = document.getElementById("inv-frame");
//     if (frame) {
//       frame.contentWindow.focus();
//       frame.contentWindow.print();
//     }
//   };

//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   return (
//     <div
//       onClick={onClose}
//       className="invoice-modal-overlay"
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         className="invoice-modal"
//       >
//         <div className="invoice-modal-header">
//           <div className="invoice-modal-title" style={{ color: primaryColor }}>
//             📄 Invoice Preview
//           </div>
//           <div className="invoice-modal-actions">
//             {sent && (
//               <span className="invoice-modal-sent-badge">
//                 ✓ Sent!
//               </span>
//             )}
//             <button
//               onClick={handleResend}
//               disabled={sending}
//               className="invoice-modal-resend-btn"
//               style={{ background: `${primaryColor}15`, color: primaryColor, borderColor: `${primaryColor}35` }}
//             >
//               {sending ? "Sending…" : "📧 Resend Email"}
//             </button>
//             <button
//               onClick={handlePrint}
//               className="invoice-modal-print-btn"
//               style={{ background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)` }}
//             >
//               🖨 Print / PDF
//             </button>
//             <button
//               onClick={onClose}
//               className="invoice-modal-close-btn"
//             >
//               ×
//             </button>
//           </div>
//         </div>
//         <div className="invoice-modal-body">
//           {loading ? (
//             <div className="invoice-modal-loading">
//               <div className="invoice-modal-loading-icon">⏳</div>
//               <div>Loading invoice…</div>
//             </div>
//           ) : (
//             <iframe
//               id="inv-frame"
//               srcDoc={html}
//               className="invoice-modal-iframe"
//               title="Invoice"
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // Elegant Invoice Card
// const InvoiceCard = ({ invoice, onView }) => {
//   const isRefunded = invoice.status === "refunded" || invoice.type === "refund";
//   const isCancelled = invoice.status === "cancelled" || invoice.type === "cancellation";
//   const type = isRefunded ? TYPE_CFG.refund : (isCancelled ? TYPE_CFG.cancellation : (TYPE_CFG[invoice.type] || TYPE_CFG.booking));
//   const status = STATUS_CFG[invoice.status] || STATUS_CFG.issued;
//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   const sym = invoice.currency_symbol || "₹";
//   const pos = invoice.currency_symbol_position || "before";
//   const dec = invoice.currency_decimals ?? 2;
//   const locale = invoice.number_format_locale || "en-IN";

//   const f = (n) => {
//     if (n == null) return "—";
//     const formatted = new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec,
//       maximumFractionDigits: dec,
//     }).format(parseFloat(n));
//     return pos === "after" ? `${formatted} ${sym}` : `${sym}${formatted}`;
//   };

//   const labels = invoice.fee_labels || {};
//   const fees = [
//     invoice.processing_fee > 0 && { label: labels.processing || "Processing", val: invoice.processing_fee },
//     invoice.stamp_duty > 0 && { label: labels.stamp_duty || "Stamp Duty", val: invoice.stamp_duty },
//     invoice.registration_fee > 0 && { label: labels.registration || "Reg Fee", val: invoice.registration_fee },
//     invoice.maintenance_charge > 0 && { label: labels.maintenance || "Maintenance", val: invoice.maintenance_charge },
//     invoice.custom_fee1 > 0 && { label: labels.custom1 || "Custom 1", val: invoice.custom_fee1 },
//     invoice.custom_fee2 > 0 && { label: labels.custom2 || "Custom 2", val: invoice.custom_fee2 },
//     invoice.tax_amount > 0 && { label: labels.tax || invoice.tax_label || "Tax", val: invoice.tax_amount },
//   ].filter(Boolean);

//   // For refunded invoices, show negative amounts
//   const displayAmount = isRefunded ? -Math.abs(parseFloat(invoice.amount_paid || 0)) : parseFloat(invoice.amount_paid || 0);
//   const displayTotal = isRefunded ? -Math.abs(parseFloat(invoice.total_amount || 0)) : parseFloat(invoice.total_amount || 0);
//   const displayBalance = isRefunded ? -Math.abs(parseFloat(invoice.balance_due || 0)) : parseFloat(invoice.balance_due || 0);

//   return (
//     <div
//       onClick={() => onView(invoice.id)}
//       className="invoice-card"
//       style={{
//         background: isRefunded ? "rgba(148,163,184,0.04)" : "var(--card-bg)",
//         border: `1px solid ${isRefunded ? "rgba(148,163,184,0.2)" : "var(--card-border)"}`,
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.borderColor = isRefunded ? "#94a3b860" : primaryColor + "40";
//         e.currentTarget.style.transform = "translateY(-2px)";
//         e.currentTarget.style.boxShadow = `0 8px 30px ${primaryColor}10`;
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.borderColor = isRefunded ? "rgba(148,163,184,0.2)" : "var(--card-border)";
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.boxShadow = "none";
//       }}
//     >
//       <div className="invoice-card-header">
//         <div className="invoice-card-info">
//           <div className="invoice-card-badges">
//             <span className="invoice-card-type-badge" style={{
//               background: type.bg,
//               color: type.color,
//               border: `1px solid ${type.color}33`,
//             }}>
//               {type.icon} {type.label}
//             </span>
//             <span className="invoice-card-number" style={{ color: "var(--text-dark)" }}>
//               #{invoice.invoice_number}
//             </span>
//             <span className="invoice-card-status-badge" style={{
//               color: status.color,
//               background: `${status.color}10`,
//             }}>
//               {status.label}
//             </span>
//           </div>

//           <div className="invoice-card-details">
//             🏠 Unit {invoice.plot_number}
//             {invoice.plot_type && ` · ${invoice.plot_type}`}
//             {invoice.area && ` · ${invoice.area} ${invoice.area_unit || ""}`}
//             {invoice.project_name && ` · ${invoice.project_name}`}
//           </div>

//           {invoice.type === "milestone" && invoice.meta?.milestone_label && (
//             <div className="invoice-card-milestone" style={{ color: "#22c55e" }}>
//               💳 {invoice.meta.milestone_label}
//             </div>
//           )}

//           <div className="invoice-card-meta">
//             Booking #{invoice.booking_id} ·{" "}
//             {new Date(invoice.issued_at).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//               year: "numeric",
//             })}
//             {invoice.email_sent_at && (
//               <span className="invoice-card-email-sent" style={{ color: "#22c55e" }}>
//                 ✉ Sent{" "}
//                 {new Date(invoice.email_sent_at).toLocaleDateString("en-IN", {
//                   day: "numeric",
//                   month: "short",
//                 })}
//                 {invoice.broker_copy_sent && " + broker copy"}
//               </span>
//             )}
//           </div>

//           {fees.length > 0 && (
//             <div className="invoice-card-fees">
//               {fees.map((fee, i) => (
//                 <span
//                   key={i}
//                   className="invoice-card-fee"
//                 >
//                   {fee.label}: {f(fee.val)}
//                 </span>
//               ))}
//             </div>
//           )}
//         </div>

//         <div className="invoice-card-amount">
//           <div className="invoice-card-amount-label">
//             {invoice.type === "milestone" ? "Received" : (isRefunded ? "Refunded Amount" : "Amount Paid")}
//           </div>
//           <div className="invoice-card-amount-value" style={{ 
//             color: isRefunded ? "#94a3b8" : primaryColor,
//             fontSize: isRefunded ? "22px" : "26px"
//           }}>
//             {isRefunded ? `−${f(Math.abs(displayAmount))}` : f(displayAmount)}
//           </div>
//           {displayTotal > 0 && Math.abs(displayTotal) > Math.abs(displayAmount) && (
//             <div className="invoice-card-total">
//               of {f(Math.abs(displayTotal))}
//             </div>
//           )}
//           {displayBalance !== 0 && !isRefunded && (
//             displayBalance > 0 ? (
//               <div className="invoice-card-due" style={{ color: "#f59e0b" }}>
//                 Due: {f(displayBalance)}
//               </div>
//             ) : (
//               invoice.type !== "milestone" && (
//                 <div className="invoice-card-paid" style={{ color: "#22c55e" }}>
//                   ✓ Fully Paid
//                 </div>
//               )
//             )
//           )}
//           {isRefunded && (
//             <div className="invoice-card-refunded" style={{ color: "#94a3b8" }}>
//               ✓ Amount Refunded
//             </div>
//           )}
//           {isCancelled && !isRefunded && (
//             <div className="invoice-card-cancelled" style={{ color: "#ef4444" }}>
//               ✕ Invoice Cancelled
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="invoice-card-footer" style={{ color: primaryColor }}>
//         🔍 Tap to view & print invoice →
//       </div>
//     </div>
//   );
// };

// // Elegant Stat Card for Invoices
// const InvoiceStatCard = ({ icon, label, value, color }) => (
//   <div className="invoice-stat-card"
//     onMouseEnter={(e) => {
//       e.currentTarget.style.borderColor = color;
//       e.currentTarget.style.transform = "translateY(-2px)";
//     }}
//     onMouseLeave={(e) => {
//       e.currentTarget.style.borderColor = "var(--card-border)";
//       e.currentTarget.style.transform = "translateY(0)";
//     }}>
//     <div className="invoice-stat-card-icon">{icon}</div>
//     <div className="invoice-stat-card-value" style={{ color }}>{value}</div>
//     <div className="invoice-stat-card-label">{label}</div>
//   </div>
// );

// export default function InvoicesTab({ user, fmt }) {
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState("all");
//   const [previewId, setPreviewId] = useState(null);
//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   const fetchInvoices = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`${API_BASE}/invoices`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const data = await res.json();
//       setInvoices(Array.isArray(data) ? data : []);
//     } catch (_) { }
//     setLoading(false);
//   }, [user.token]);

//   useEffect(() => {
//     fetchInvoices();
//   }, [fetchInvoices]);

//   if (!user) return null;

//   // Filter invoices, excluding cancelled ones from totals calculation
//   const activeInvoices = invoices.filter(i => i.status !== "cancelled");
//   const filtered = filter === "all" 
//     ? invoices 
//     : invoices.filter((i) => i.type === filter);

//   const sym = invoices[0]?.currency_symbol || "₹";
//   const locale = invoices[0]?.number_format_locale || "en-IN";
//   const dec = invoices[0]?.currency_decimals ?? 2;
//   const fStat = (n) =>
//     sym +
//     new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec,
//       maximumFractionDigits: dec,
//     }).format(n);

//   // Calculate totals - exclude cancelled and refunded from balance calculations
//   const milestonesByBooking = activeInvoices
//     .filter((i) => i.type === "milestone" && i.status !== "refunded")
//     .reduce((acc, i) => {
//       const bid = i.booking_id;
//       acc[bid] = (acc[bid] || 0) + parseFloat(i.amount_paid || 0);
//       return acc;
//     }, {});

//   const bookingInvoices = activeInvoices.filter(
//     (i) => i.type === "booking" && i.status !== "refunded" && i.status !== "cancelled"
//   );

//   const refundedInvoices = invoices.filter(i => i.status === "refunded" || i.type === "refund");
//   const totalRefunded = refundedInvoices.reduce((s, i) => s + parseFloat(i.amount_paid || 0), 0);

//   const totalPaid = bookingInvoices.reduce((s, i) => {
//     const milestonePaid = milestonesByBooking[i.booking_id];
//     return s + (milestonePaid != null ? milestonePaid : parseFloat(i.amount_paid || 0));
//   }, 0) - totalRefunded;

//   const totalDue = bookingInvoices.reduce((s, i) => {
//     const total = parseFloat(i.total_amount || 0);
//     const milestonePaid = milestonesByBooking[i.booking_id];
//     const paid = milestonePaid != null ? milestonePaid : parseFloat(i.amount_paid || 0);
//     return s + Math.max(0, total - paid);
//   }, 0);

//   if (loading)
//     return (
//       <div className="invoices-loading">
//         <div className="invoices-loading-icon">⏳</div>
//         <div>Loading invoices…</div>
//       </div>
//     );

//   return (
//     <div className="invoices-tab">
//       {previewId && (
//         <InvoicePreviewModal
//           invoiceId={previewId}
//           token={user.token}
//           onClose={() => setPreviewId(null)}
//         />
//       )}

//       {invoices.length > 0 && (
//         <div className="invoices-stats">
//           <InvoiceStatCard 
//             label="Total Invoices" 
//             value={invoices.length} 
//             icon="📄" 
//             color={primaryColor} 
//           />
//           <InvoiceStatCard 
//             label="Total Paid" 
//             value={fStat(totalPaid)} 
//             icon="💰" 
//             color="#22c55e" 
//           />
//           {totalRefunded > 0 && (
//             <InvoiceStatCard 
//               label="Refunded Amount" 
//               value={fStat(totalRefunded)} 
//               icon="↺" 
//               color="#94a3b8" 
//             />
//           )}
//           <InvoiceStatCard 
//             label="Balance Due" 
//             value={fStat(totalDue)} 
//             icon="⏳" 
//             color={totalDue > 0 ? "#f59e0b" : "#22c55e"} 
//           />
//         </div>
//       )}

//       <div className="invoices-filters">
//         {[
//           ["all", "All"],
//           ["booking", "Tax Invoices"],
//           ["milestone", "Receipts"],
//           ["refund", "Refund Notes"],
//           ["cancellation", "Cancellations"],
//         ].map(([val, label]) => {
//           const count = val === "all" 
//             ? invoices.length 
//             : invoices.filter(i => i.type === val || (val === "refund" && i.status === "refunded")).length;
//           return (
//             <button
//               key={val}
//               onClick={() => setFilter(val)}
//               className={`invoices-filter-btn ${filter === val ? 'active' : ''}`}
//               style={{
//                 background: filter === val ? `${primaryColor}12` : "transparent",
//                 color: filter === val ? primaryColor : "var(--text-muted)",
//                 border: filter === val ? `1px solid ${primaryColor}30` : "1px solid transparent",
//               }}
//             >
//               {label}
//               {count > 0 && (
//                 <span className="invoices-filter-count" style={{
//                   background: filter === val ? `${primaryColor}20` : "var(--page-bg)",
//                   color: filter === val ? primaryColor : "var(--text-muted)",
//                 }}>
//                   {count}
//                 </span>
//               )}
//             </button>
//           );
//         })}
//       </div>

//       {filtered.length === 0 && (
//         <div className="invoices-empty">
//           <div className="invoices-empty-icon">📄</div>
//           <div className="invoices-empty-title">
//             No invoices yet
//           </div>
//           <div className="invoices-empty-text">
//             Invoices are auto-generated when a booking is confirmed and for each milestone payment.
//           </div>
//         </div>
//       )}

//       <div className="invoices-list">
//         {filtered.map((inv) => (
//           <InvoiceCard key={inv.id} invoice={inv} onView={setPreviewId} />
//         ))}
//       </div>

//       <style>{`
//         .invoice-modal-overlay {
//           position: fixed;
//           inset: 0;
//           z-index: 2000;
//           background: rgba(0,0,0,0.8);
//           backdrop-filter: blur(8px);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 20px;
//         }
//         .invoice-modal {
//           background: #fff;
//           border-radius: 24px;
//           width: 100%;
//           max-width: 900px;
//           height: 90vh;
//           display: flex;
//           flex-direction: column;
//           box-shadow: 0 32px 80px rgba(0,0,0,0.3);
//           overflow: hidden;
//         }
//         .invoice-modal-header {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 16px 24px;
//           background: #1a1a2e;
//           flex-shrink: 0;
//         }
//         .invoice-modal-title {
//           font-size: 15px;
//           font-weight: 700;
//         }
//         .invoice-modal-actions {
//           display: flex;
//           gap: 12px;
//           align-items: center;
//         }
//         .invoice-modal-sent-badge {
//           font-size: 12px;
//           color: #22c55e;
//           font-weight: 600;
//           background: #22c55e15;
//           padding: 4px 12px;
//           border-radius: 20px;
//         }
//         .invoice-modal-resend-btn {
//           padding: 8px 18px;
//           border-radius: 10px;
//           cursor: pointer;
//           font-size: 13px;
//           font-weight: 600;
//           border: 1px solid;
//           transition: all 0.2s ease;
//         }
//         .invoice-modal-resend-btn:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }
//         .invoice-modal-print-btn {
//           padding: 8px 18px;
//           border-radius: 10px;
//           cursor: pointer;
//           font-size: 13px;
//           font-weight: 600;
//           color: #fff;
//           border: none;
//           transition: all 0.2s ease;
//         }
//         .invoice-modal-print-btn:hover {
//           transform: translateY(-1px);
//         }
//         .invoice-modal-close-btn {
//           background: rgba(255,255,255,0.1);
//           border: 1px solid rgba(255,255,255,0.15);
//           color: #fff;
//           width: 36px;
//           height: 36px;
//           border-radius: 10px;
//           cursor: pointer;
//           font-size: 18px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.2s ease;
//         }
//         .invoice-modal-close-btn:hover {
//           background: rgba(255,255,255,0.2);
//         }
//         .invoice-modal-body {
//           flex: 1;
//           overflow: hidden;
//           background: #f4f4f4;
//         }
//         .invoice-modal-loading {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           height: 100%;
//           color: #64748b;
//           flex-direction: column;
//           gap: 16px;
//         }
//         .invoice-modal-loading-icon {
//           font-size: 48px;
//         }
//         .invoice-modal-iframe {
//           width: 100%;
//           height: 100%;
//           border: none;
//         }
//         .invoices-loading {
//           text-align: center;
//           padding: 80px 0;
//           color: var(--text-muted);
//         }
//         .invoices-loading-icon {
//           font-size: 48px;
//           margin-bottom: 16px;
//         }
//         .invoice-stat-card {
//           background: var(--card-bg);
//           border: 1px solid var(--card-border);
//           border-radius: 16px;
//           padding: 16px 18px;
//           transition: all 0.2s ease;
//         }
//         .invoice-stat-card-icon {
//           font-size: 28px;
//           margin-bottom: 8px;
//         }
//         .invoice-stat-card-value {
//           font-size: 22px;
//           font-weight: 800;
//         }
//         .invoice-stat-card-label {
//           font-size: 12px;
//           color: var(--text-muted);
//           margin-top: 4px;
//         }
//         .invoices-stats {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
//           gap: 12px;
//           margin-bottom: 28px;
//         }
//         .invoices-filters {
//           display: flex;
//           gap: 6px;
//           margin-bottom: 24px;
//           background: var(--card-bg);
//           padding: 6px;
//           border-radius: 16px;
//           border: 1px solid var(--card-border);
//           width: fit-content;
//           flex-wrap: wrap;
//         }
//         .invoices-filter-btn {
//           padding: 8px 20px;
//           border-radius: 12px;
//           cursor: pointer;
//           font-size: 13px;
//           font-weight: 600;
//           transition: all 0.2s ease;
//           font-family: var(--font-body, inherit);
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .invoices-filter-count {
//           padding: 2px 8px;
//           border-radius: 20px;
//           font-size: 11px;
//           font-weight: 700;
//           border: 1px solid var(--card-border);
//         }
//         .invoices-empty {
//           text-align: center;
//           padding: 80px 0;
//         }
//         .invoices-empty-icon {
//           font-size: 64px;
//           margin-bottom: 16px;
//         }
//         .invoices-empty-title {
//           font-size: 18px;
//           font-weight: 700;
//           color: var(--text-dark);
//           margin-bottom: 10px;
//           font-family: var(--font-heading, inherit);
//         }
//         .invoices-empty-text {
//           font-size: 14px;
//           color: var(--text-muted);
//         }
//         .invoices-list {
//           display: flex;
//           flex-direction: column;
//           gap: 14px;
//         }
//         .invoice-card {
//           border-radius: 20px;
//           padding: 20px;
//           cursor: pointer;
//           transition: all 0.3s cubic-bezier(0.2, 0.9, 0.4, 1.1);
//         }
//         .invoice-card-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           gap: 16px;
//           flex-wrap: wrap;
//         }
//         .invoice-card-info {
//           flex: 1;
//         }
//         .invoice-card-badges {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           flex-wrap: wrap;
//           margin-bottom: 10px;
//         }
//         .invoice-card-type-badge {
//           padding: 4px 12px;
//           border-radius: 20px;
//           font-size: 11px;
//           font-weight: 700;
//         }
//         .invoice-card-number {
//           font-size: 16px;
//           font-weight: 800;
//           font-family: var(--font-heading, inherit);
//         }
//         .invoice-card-status-badge {
//           font-size: 11px;
//           font-weight: 700;
//           padding: 3px 10px;
//           border-radius: 20px;
//         }
//         .invoice-card-details {
//           font-size: 13px;
//           color: var(--text-muted);
//           margin-bottom: 6px;
//         }
//         .invoice-card-milestone {
//           font-size: 12px;
//           font-weight: 600;
//           margin-bottom: 4px;
//         }
//         .invoice-card-meta {
//           font-size: 11px;
//           color: var(--text-muted);
//           margin-top: 6px;
//         }
//         .invoice-card-email-sent {
//           margin-left: 12px;
//         }
//         .invoice-card-fees {
//           display: flex;
//           gap: 8px;
//           flex-wrap: wrap;
//           margin-top: 12px;
//         }
//         .invoice-card-fee {
//           font-size: 11px;
//           font-weight: 600;
//           padding: 3px 10px;
//           border-radius: 12px;
//           background: var(--page-bg);
//           color: var(--text-muted);
//           border: 1px solid var(--card-border);
//         }
//         .invoice-card-amount {
//           text-align: right;
//           flex-shrink: 0;
//         }
//         .invoice-card-amount-label {
//           font-size: 11px;
//           color: var(--text-muted);
//           margin-bottom: 4px;
//         }
//         .invoice-card-amount-value {
//           font-weight: 800;
//           font-family: var(--font-heading, inherit);
//         }
//         .invoice-card-total {
//           font-size: 12px;
//           color: var(--text-muted);
//           margin-top: 2px;
//         }
//         .invoice-card-due {
//           font-size: 13px;
//           margin-top: 6px;
//           font-weight: 700;
//         }
//         .invoice-card-paid {
//           font-size: 12px;
//           margin-top: 6px;
//           font-weight: 600;
//         }
//         .invoice-card-refunded {
//           font-size: 12px;
//           margin-top: 6px;
//           font-weight: 600;
//         }
//         .invoice-card-cancelled {
//           font-size: 12px;
//           margin-top: 6px;
//           font-weight: 600;
//         }
//         .invoice-card-footer {
//           margin-top: 16px;
//           font-size: 12px;
//           font-weight: 600;
//           display: flex;
//           align-items: center;
//           gap: 6px;
//         }
//         @media (max-width: 768px) {
//           .invoices-stats {
//             grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
//           }
//           .invoice-card-amount-value {
//             font-size: 20px;
//           }
//           .invoice-card-header {
//             flex-direction: column;
//           }
//           .invoice-card-amount {
//             text-align: left;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// // InvoicesTab.jsx - Updated to handle API response format
// import { useEffect, useState, useCallback } from "react";
// import { apiUrl, imgUrl } from "../apiUrl";

// const API_BASE = `${apiUrl}/api`;

// const TYPE_CFG = {
//   booking: {
//     icon: "📄",
//     label: "Tax Invoice",
//     color: "var(--primary-color)",
//     bg: "rgba(var(--primary-rgb), 0.12)",
//   },
//   milestone: {
//     icon: "🧾",
//     label: "Payment Receipt",
//     color: "#22c55e",
//     bg: "rgba(34,197,94,0.12)",
//   },
//   refund: {
//     icon: "↺",
//     label: "Refund Note",
//     color: "#94a3b8",
//     bg: "rgba(148,163,184,0.12)",
//   },
//   cancellation: {
//     icon: "✕",
//     label: "Cancellation",
//     color: "#ef4444",
//     bg: "rgba(239,68,68,0.12)",
//   },
// };

// const STATUS_CFG = {
//   issued: { color: "#22c55e", label: "Issued" },
//   cancelled: { color: "#ef4444", label: "Cancelled" },
//   revised: { color: "#f59e0b", label: "Revised" },
//   refunded: { color: "#94a3b8", label: "Refunded" },
// };

// // Elegant Modal
// const InvoicePreviewModal = ({ invoiceId, token, onClose }) => {
//   const [html, setHtml] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [sending, setSending] = useState(false);
//   const [sent, setSent] = useState(false);

//   useEffect(() => {
//     if (!invoiceId) return;
//     fetch(`${API_BASE}/invoices/${invoiceId}/html`, {
//       headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
//     })
//       .then((r) => r.json())
//       .then((d) => {
//         setHtml(d.html || "");
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));

//     const esc = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     window.addEventListener("keydown", esc);
//     return () => window.removeEventListener("keydown", esc);
//   }, [invoiceId]);

//   const handleResend = async () => {
//     setSending(true);
//     try {
//       await fetch(`${API_BASE}/invoices/${invoiceId}/resend`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//         },
//       });
//       setSent(true);
//       setTimeout(() => setSent(false), 3000);
//     } catch (_) { }
//     setSending(false);
//   };

//   const handlePrint = () => {
//     const frame = document.getElementById("inv-frame");
//     if (frame) {
//       frame.contentWindow.focus();
//       frame.contentWindow.print();
//     }
//   };

//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   return (
//     <div onClick={onClose} className="invoice-modal-overlay">
//       <div onClick={(e) => e.stopPropagation()} className="invoice-modal">
//         <div className="invoice-modal-header">
//           <div className="invoice-modal-title" style={{ color: primaryColor }}>
//             📄 Invoice Preview
//           </div>
//           <div className="invoice-modal-actions">
//             {sent && <span className="invoice-modal-sent-badge">✓ Sent!</span>}
//             <button
//               onClick={handleResend}
//               disabled={sending}
//               className="invoice-modal-resend-btn"
//               style={{ background: `${primaryColor}15`, color: primaryColor, borderColor: `${primaryColor}35` }}
//             >
//               {sending ? "Sending…" : "📧 Resend Email"}
//             </button>
//             <button onClick={handlePrint} className="invoice-modal-print-btn" style={{ background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)` }}>
//               🖨 Print / PDF
//             </button>
//             <button onClick={onClose} className="invoice-modal-close-btn">×</button>
//           </div>
//         </div>
//         <div className="invoice-modal-body">
//           {loading ? (
//             <div className="invoice-modal-loading">
//               <div className="invoice-modal-loading-icon">⏳</div>
//               <div>Loading invoice…</div>
//             </div>
//           ) : (
//             <iframe id="inv-frame" srcDoc={html} className="invoice-modal-iframe" title="Invoice" />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// // Elegant Invoice Card
// const InvoiceCard = ({ invoice, onView }) => {
//   const isRefunded = invoice.status === "refunded" || invoice.type === "refund";
//   const isCancelled = invoice.status === "cancelled" || invoice.type === "cancellation";
//   const type = isRefunded ? TYPE_CFG.refund : (isCancelled ? TYPE_CFG.cancellation : (TYPE_CFG[invoice.type] || TYPE_CFG.booking));
//   const status = STATUS_CFG[invoice.status] || STATUS_CFG.issued;
//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   const sym = invoice.currency_symbol || "₹";
//   const pos = invoice.currency_symbol_position || "before";
//   const dec = invoice.currency_decimals ?? 2;
//   const locale = invoice.number_format_locale || "en-IN";

//   const f = (n) => {
//     if (n == null) return "—";
//     const formatted = new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec,
//       maximumFractionDigits: dec,
//     }).format(parseFloat(n));
//     return pos === "after" ? `${formatted} ${sym}` : `${sym}${formatted}`;
//   };

//   const labels = invoice.fee_labels || {};
//   const fees = [
//     invoice.processing_fee > 0 && { label: labels.processing || "Processing", val: invoice.processing_fee },
//     invoice.stamp_duty > 0 && { label: labels.stamp_duty || "Stamp Duty", val: invoice.stamp_duty },
//     invoice.registration_fee > 0 && { label: labels.registration || "Reg Fee", val: invoice.registration_fee },
//     invoice.maintenance_charge > 0 && { label: labels.maintenance || "Maintenance", val: invoice.maintenance_charge },
//     invoice.custom_fee1 > 0 && { label: labels.custom1 || "Custom 1", val: invoice.custom_fee1 },
//     invoice.custom_fee2 > 0 && { label: labels.custom2 || "Custom 2", val: invoice.custom_fee2 },
//     invoice.tax_amount > 0 && { label: labels.tax || invoice.tax_label || "Tax", val: invoice.tax_amount },
//   ].filter(Boolean);

//   const displayAmount = isRefunded ? -Math.abs(parseFloat(invoice.amount_paid || 0)) : parseFloat(invoice.amount_paid || 0);
//   const displayTotal = isRefunded ? -Math.abs(parseFloat(invoice.total_amount || 0)) : parseFloat(invoice.total_amount || 0);
//   const displayBalance = isRefunded ? -Math.abs(parseFloat(invoice.balance_due || 0)) : parseFloat(invoice.balance_due || 0);

//   return (
//     <div
//       onClick={() => onView(invoice.id)}
//       className="invoice-card"
//       style={{
//         background: isRefunded ? "rgba(148,163,184,0.04)" : "var(--card-bg)",
//         border: `1px solid ${isRefunded ? "rgba(148,163,184,0.2)" : "var(--card-border)"}`,
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.borderColor = isRefunded ? "#94a3b860" : primaryColor + "40";
//         e.currentTarget.style.transform = "translateY(-2px)";
//         e.currentTarget.style.boxShadow = `0 8px 30px ${primaryColor}10`;
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.borderColor = isRefunded ? "rgba(148,163,184,0.2)" : "var(--card-border)";
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.boxShadow = "none";
//       }}
//     >
//       <div className="invoice-card-header">
//         <div className="invoice-card-info">
//           <div className="invoice-card-badges">
//             <span className="invoice-card-type-badge" style={{ background: type.bg, color: type.color, border: `1px solid ${type.color}33` }}>
//               {type.icon} {type.label}
//             </span>
//             <span className="invoice-card-number" style={{ color: "var(--text-dark)" }}>#{invoice.invoice_number}</span>
//             <span className="invoice-card-status-badge" style={{ color: status.color, background: `${status.color}10` }}>
//               {status.label}
//             </span>
//           </div>

//           <div className="invoice-card-details">
//             🏠 Unit {invoice.plot_number}
//             {invoice.plot_type && ` · ${invoice.plot_type}`}
//             {invoice.area && ` · ${invoice.area} ${invoice.area_unit || ""}`}
//             {invoice.project_name && ` · ${invoice.project_name}`}
//           </div>

//           {invoice.type === "milestone" && invoice.meta?.milestone_label && (
//             <div className="invoice-card-milestone" style={{ color: "#22c55e" }}>💳 {invoice.meta.milestone_label}</div>
//           )}

//           <div className="invoice-card-meta">
//             Booking #{invoice.booking_id} ·{" "}
//             {new Date(invoice.issued_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
//             {invoice.email_sent_at && (
//               <span className="invoice-card-email-sent" style={{ color: "#22c55e" }}>
//                 ✉ Sent {new Date(invoice.email_sent_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
//                 {invoice.broker_copy_sent && " + broker copy"}
//               </span>
//             )}
//           </div>

//           {fees.length > 0 && (
//             <div className="invoice-card-fees">
//               {fees.map((fee, i) => (
//                 <span key={i} className="invoice-card-fee">{fee.label}: {f(fee.val)}</span>
//               ))}
//             </div>
//           )}
//         </div>

//         <div className="invoice-card-amount">
//           <div className="invoice-card-amount-label">
//             {invoice.type === "milestone" ? "Received" : (isRefunded ? "Refunded Amount" : "Amount Paid")}
//           </div>
//           <div className="invoice-card-amount-value" style={{ color: isRefunded ? "#94a3b8" : primaryColor, fontSize: isRefunded ? "22px" : "26px" }}>
//             {isRefunded ? `−${f(Math.abs(displayAmount))}` : f(displayAmount)}
//           </div>
//           {displayTotal > 0 && Math.abs(displayTotal) > Math.abs(displayAmount) && (
//             <div className="invoice-card-total">of {f(Math.abs(displayTotal))}</div>
//           )}
//           {displayBalance !== 0 && !isRefunded && (
//             displayBalance > 0 ? (
//               <div className="invoice-card-due" style={{ color: "#f59e0b" }}>Due: {f(displayBalance)}</div>
//             ) : (
//               invoice.type !== "milestone" && (
//                 <div className="invoice-card-paid" style={{ color: "#22c55e" }}>✓ Fully Paid</div>
//               )
//             )
//           )}
//           {isRefunded && <div className="invoice-card-refunded" style={{ color: "#94a3b8" }}>✓ Amount Refunded</div>}
//           {isCancelled && !isRefunded && <div className="invoice-card-cancelled" style={{ color: "#ef4444" }}>✕ Invoice Cancelled</div>}
//         </div>
//       </div>

//       <div className="invoice-card-footer" style={{ color: primaryColor }}>🔍 Tap to view & print invoice →</div>
//     </div>
//   );
// };

// // Elegant Stat Card for Invoices
// const InvoiceStatCard = ({ icon, label, value, color }) => (
//   <div className="invoice-stat-card" onMouseEnter={(e) => { e.currentTarget.style.borderColor = color; e.currentTarget.style.transform = "translateY(-2px)"; }} onMouseLeave={(e) => { e.currentTarget.style.borderColor = "var(--card-border)"; e.currentTarget.style.transform = "translateY(0)"; }}>
//     <div className="invoice-stat-card-icon">{icon}</div>
//     <div className="invoice-stat-card-value" style={{ color }}>{value}</div>
//     <div className="invoice-stat-card-label">{label}</div>
//   </div>
// );

// export default function InvoicesTab({ user, fmt }) {
//   const [invoices, setInvoices] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [filter, setFilter] = useState("all");
//   const [previewId, setPreviewId] = useState(null);
//   const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

//   const fetchInvoices = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await fetch(`${API_BASE}/invoices`, {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           Accept: "application/json",
//         },
//       });
//       const data = await res.json();
      
//       console.log('API Response:', data); // Debug log
      
//       // Handle the response format - the API returns { success: true, invoices: [...], stats: {...} }
//       if (data.success && Array.isArray(data.invoices)) {
//         setInvoices(data.invoices);
//         setStats(data.stats);
//       } else if (Array.isArray(data)) {
//         // Fallback for older API format
//         setInvoices(data);
//         setStats(null);
//       } else {
//         console.error('Unexpected API response format:', data);
//         setInvoices([]);
//       }
//     } catch (error) {
//       console.error('Error fetching invoices:', error);
//       setInvoices([]);
//     }
//     setLoading(false);
//   }, [user.token]);

//   useEffect(() => {
//     if (user?.token) {
//       fetchInvoices();
//     }
//   }, [fetchInvoices, user?.token]);

//   if (!user) return null;

//   // Filter invoices
//   const filtered = filter === "all" 
//     ? invoices 
//     : invoices.filter((i) => i.type === filter);

//   // Use stats from API if available, otherwise calculate locally
//   const totalInvoices = stats?.total_invoices || invoices.length;
//   const totalPaid = stats?.total_paid || 0;
//   const totalRefunded = stats?.total_refunded || 0;
//   const totalDue = stats?.total_due || 0;

//   const sym = invoices[0]?.currency_symbol || "₹";
//   const locale = invoices[0]?.number_format_locale || "en-IN";
//   const dec = invoices[0]?.currency_decimals ?? 2;
  
//   const fStat = (n) => {
//     if (n == null) return "₹0.00";
//     return sym + new Intl.NumberFormat(locale, {
//       minimumFractionDigits: dec,
//       maximumFractionDigits: dec,
//     }).format(n);
//   };

//   if (loading) {
//     return (
//       <div className="invoices-loading">
//         <div className="invoices-loading-icon">⏳</div>
//         <div>Loading invoices…</div>
//       </div>
//     );
//   }

//   return (
//     <div className="invoices-tab">
//       {previewId && (
//         <InvoicePreviewModal
//           invoiceId={previewId}
//           token={user.token}
//           onClose={() => setPreviewId(null)}
//         />
//       )}

//       {invoices.length > 0 && (
//         <div className="invoices-stats">
//           <InvoiceStatCard label="Total Invoices" value={totalInvoices} icon="📄" color={primaryColor} />
//           <InvoiceStatCard label="Total Paid" value={fStat(totalPaid)} icon="💰" color="#22c55e" />
//           {totalRefunded > 0 && (
//             <InvoiceStatCard label="Refunded Amount" value={fStat(totalRefunded)} icon="↺" color="#94a3b8" />
//           )}
//           <InvoiceStatCard label="Balance Due" value={fStat(totalDue)} icon="⏳" color={totalDue > 0 ? "#f59e0b" : "#22c55e"} />
//         </div>
//       )}

//       <div className="invoices-filters">
//         {[
//           ["all", "All"],
//           ["booking", "Tax Invoices"],
//           ["milestone", "Receipts"],
//           ["refund", "Refund Notes"],
//           ["cancellation", "Cancellations"],
//         ].map(([val, label]) => {
//           const count = val === "all" 
//             ? invoices.length 
//             : invoices.filter(i => i.type === val).length;
//           return (
//             <button
//               key={val}
//               onClick={() => setFilter(val)}
//               className={`invoices-filter-btn ${filter === val ? 'active' : ''}`}
//               style={{
//                 background: filter === val ? `${primaryColor}12` : "transparent",
//                 color: filter === val ? primaryColor : "var(--text-muted)",
//                 border: filter === val ? `1px solid ${primaryColor}30` : "1px solid transparent",
//               }}
//             >
//               {label}
//               {count > 0 && (
//                 <span className="invoices-filter-count" style={{
//                   background: filter === val ? `${primaryColor}20` : "var(--page-bg)",
//                   color: filter === val ? primaryColor : "var(--text-muted)",
//                 }}>
//                   {count}
//                 </span>
//               )}
//             </button>
//           );
//         })}
//       </div>

//       {filtered.length === 0 ? (
//         <div className="invoices-empty">
//           <div className="invoices-empty-icon">📄</div>
//           <div className="invoices-empty-title">No invoices yet</div>
//           <div className="invoices-empty-text">Invoices are auto-generated when a booking is confirmed and for each milestone payment.</div>
//         </div>
//       ) : (
//         <div className="invoices-list">
//           {filtered.map((inv) => (
//             <InvoiceCard key={inv.id} invoice={inv} onView={setPreviewId} />
//           ))}
//         </div>
//       )}

//       <style>{`
//         .invoice-modal-overlay {
//           position: fixed;
//           inset: 0;
//           z-index: 2000;
//           background: rgba(0,0,0,0.8);
//           backdrop-filter: blur(8px);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 20px;
//         }
//         .invoice-modal {
//           background: #fff;
//           border-radius: 24px;
//           width: 100%;
//           max-width: 900px;
//           height: 90vh;
//           display: flex;
//           flex-direction: column;
//           box-shadow: 0 32px 80px rgba(0,0,0,0.3);
//           overflow: hidden;
//         }
//         .invoice-modal-header {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 16px 24px;
//           background: #1a1a2e;
//           flex-shrink: 0;
//         }
//         .invoice-modal-title {
//           font-size: 15px;
//           font-weight: 700;
//         }
//         .invoice-modal-actions {
//           display: flex;
//           gap: 12px;
//           align-items: center;
//         }
//         .invoice-modal-sent-badge {
//           font-size: 12px;
//           color: #22c55e;
//           font-weight: 600;
//           background: #22c55e15;
//           padding: 4px 12px;
//           border-radius: 20px;
//         }
//         .invoice-modal-resend-btn {
//           padding: 8px 18px;
//           border-radius: 10px;
//           cursor: pointer;
//           font-size: 13px;
//           font-weight: 600;
//           border: 1px solid;
//           transition: all 0.2s ease;
//         }
//         .invoice-modal-resend-btn:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }
//         .invoice-modal-print-btn {
//           padding: 8px 18px;
//           border-radius: 10px;
//           cursor: pointer;
//           font-size: 13px;
//           font-weight: 600;
//           color: #fff;
//           border: none;
//           transition: all 0.2s ease;
//         }
//         .invoice-modal-print-btn:hover {
//           transform: translateY(-1px);
//         }
//         .invoice-modal-close-btn {
//           background: rgba(255,255,255,0.1);
//           border: 1px solid rgba(255,255,255,0.15);
//           color: #fff;
//           width: 36px;
//           height: 36px;
//           border-radius: 10px;
//           cursor: pointer;
//           font-size: 18px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.2s ease;
//         }
//         .invoice-modal-close-btn:hover {
//           background: rgba(255,255,255,0.2);
//         }
//         .invoice-modal-body {
//           flex: 1;
//           overflow: hidden;
//           background: #f4f4f4;
//         }
//         .invoice-modal-loading {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           height: 100%;
//           color: #64748b;
//           flex-direction: column;
//           gap: 16px;
//         }
//         .invoice-modal-loading-icon {
//           font-size: 48px;
//         }
//         .invoice-modal-iframe {
//           width: 100%;
//           height: 100%;
//           border: none;
//         }
//         .invoices-loading {
//           text-align: center;
//           padding: 80px 0;
//           color: var(--text-muted);
//         }
//         .invoices-loading-icon {
//           font-size: 48px;
//           margin-bottom: 16px;
//         }
//         .invoice-stat-card {
//           background: var(--card-bg);
//           border: 1px solid var(--card-border);
//           border-radius: 16px;
//           padding: 16px 18px;
//           transition: all 0.2s ease;
//         }
//         .invoice-stat-card-icon {
//           font-size: 28px;
//           margin-bottom: 8px;
//         }
//         .invoice-stat-card-value {
//           font-size: 22px;
//           font-weight: 800;
//         }
//         .invoice-stat-card-label {
//           font-size: 12px;
//           color: var(--text-muted);
//           margin-top: 4px;
//         }
//         .invoices-stats {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
//           gap: 12px;
//           margin-bottom: 28px;
//         }
//         .invoices-filters {
//           display: flex;
//           gap: 6px;
//           margin-bottom: 24px;
//           background: var(--card-bg);
//           padding: 6px;
//           border-radius: 16px;
//           border: 1px solid var(--card-border);
//           width: fit-content;
//           flex-wrap: wrap;
//         }
//         .invoices-filter-btn {
//           padding: 8px 20px;
//           border-radius: 12px;
//           cursor: pointer;
//           font-size: 13px;
//           font-weight: 600;
//           transition: all 0.2s ease;
//           font-family: var(--font-body, inherit);
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }
//         .invoices-filter-count {
//           padding: 2px 8px;
//           border-radius: 20px;
//           font-size: 11px;
//           font-weight: 700;
//           border: 1px solid var(--card-border);
//         }
//         .invoices-empty {
//           text-align: center;
//           padding: 80px 0;
//         }
//         .invoices-empty-icon {
//           font-size: 64px;
//           margin-bottom: 16px;
//         }
//         .invoices-empty-title {
//           font-size: 18px;
//           font-weight: 700;
//           color: var(--text-dark);
//           margin-bottom: 10px;
//           font-family: var(--font-heading, inherit);
//         }
//         .invoices-empty-text {
//           font-size: 14px;
//           color: var(--text-muted);
//         }
//         .invoices-list {
//           display: flex;
//           flex-direction: column;
//           gap: 14px;
//         }
//         .invoice-card {
//           border-radius: 20px;
//           padding: 20px;
//           cursor: pointer;
//           transition: all 0.3s cubic-bezier(0.2, 0.9, 0.4, 1.1);
//         }
//         .invoice-card-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           gap: 16px;
//           flex-wrap: wrap;
//         }
//         .invoice-card-info {
//           flex: 1;
//         }
//         .invoice-card-badges {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           flex-wrap: wrap;
//           margin-bottom: 10px;
//         }
//         .invoice-card-type-badge {
//           padding: 4px 12px;
//           border-radius: 20px;
//           font-size: 11px;
//           font-weight: 700;
//         }
//         .invoice-card-number {
//           font-size: 16px;
//           font-weight: 800;
//           font-family: var(--font-heading, inherit);
//         }
//         .invoice-card-status-badge {
//           font-size: 11px;
//           font-weight: 700;
//           padding: 3px 10px;
//           border-radius: 20px;
//         }
//         .invoice-card-details {
//           font-size: 13px;
//           color: var(--text-muted);
//           margin-bottom: 6px;
//         }
//         .invoice-card-milestone {
//           font-size: 12px;
//           font-weight: 600;
//           margin-bottom: 4px;
//         }
//         .invoice-card-meta {
//           font-size: 11px;
//           color: var(--text-muted);
//           margin-top: 6px;
//         }
//         .invoice-card-email-sent {
//           margin-left: 12px;
//         }
//         .invoice-card-fees {
//           display: flex;
//           gap: 8px;
//           flex-wrap: wrap;
//           margin-top: 12px;
//         }
//         .invoice-card-fee {
//           font-size: 11px;
//           font-weight: 600;
//           padding: 3px 10px;
//           border-radius: 12px;
//           background: var(--page-bg);
//           color: var(--text-muted);
//           border: 1px solid var(--card-border);
//         }
//         .invoice-card-amount {
//           text-align: right;
//           flex-shrink: 0;
//         }
//         .invoice-card-amount-label {
//           font-size: 11px;
//           color: var(--text-muted);
//           margin-bottom: 4px;
//         }
//         .invoice-card-amount-value {
//           font-weight: 800;
//           font-family: var(--font-heading, inherit);
//         }
//         .invoice-card-total {
//           font-size: 12px;
//           color: var(--text-muted);
//           margin-top: 2px;
//         }
//         .invoice-card-due {
//           font-size: 13px;
//           margin-top: 6px;
//           font-weight: 700;
//         }
//         .invoice-card-paid {
//           font-size: 12px;
//           margin-top: 6px;
//           font-weight: 600;
//         }
//         .invoice-card-refunded {
//           font-size: 12px;
//           margin-top: 6px;
//           font-weight: 600;
//         }
//         .invoice-card-cancelled {
//           font-size: 12px;
//           margin-top: 6px;
//           font-weight: 600;
//         }
//         .invoice-card-footer {
//           margin-top: 16px;
//           font-size: 12px;
//           font-weight: 600;
//           display: flex;
//           align-items: center;
//           gap: 6px;
//         }
//         @media (max-width: 768px) {
//           .invoices-stats {
//             grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
//           }
//           .invoice-card-amount-value {
//             font-size: 20px;
//           }
//           .invoice-card-header {
//             flex-direction: column;
//           }
//           .invoice-card-amount {
//             text-align: left;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// InvoicesTab.jsx - Multi-tenant aware with API response handling
import { useEffect, useState, useCallback } from "react";
import { apiJson } from "../api/apiClient";

const TYPE_CFG = {
  booking: {
    icon: "📄",
    label: "Tax Invoice",
    color: "var(--primary-color)",
    bg: "rgba(var(--primary-rgb), 0.12)",
  },
  milestone: {
    icon: "🧾",
    label: "Payment Receipt",
    color: "#22c55e",
    bg: "rgba(34,197,94,0.12)",
  },
  refund: {
    icon: "↺",
    label: "Refund Note",
    color: "#94a3b8",
    bg: "rgba(148,163,184,0.12)",
  },
  cancellation: {
    icon: "✕",
    label: "Cancellation",
    color: "#ef4444",
    bg: "rgba(239,68,68,0.12)",
  },
};

const STATUS_CFG = {
  issued: { color: "#22c55e", label: "Issued" },
  cancelled: { color: "#ef4444", label: "Cancelled" },
  revised: { color: "#f59e0b", label: "Revised" },
  refunded: { color: "#94a3b8", label: "Refunded" },
};

// Elegant Modal
const InvoicePreviewModal = ({ invoiceId, token, onClose, tenant }) => {
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (!invoiceId || !tenant) return;
    
    apiJson(tenant, `/invoices/${invoiceId}/html`, {
      headers: { 
        Authorization: `Bearer ${token}`, 
        Accept: "application/json" 
      },
    })
      .then((d) => {
        setHtml(d.html || "");
        setLoading(false);
      })
      .catch(() => setLoading(false));

    const esc = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [invoiceId, token, tenant, onClose]);

  const handleResend = async () => {
    setSending(true);
    try {
      await apiJson(tenant, `/invoices/${invoiceId}/resend`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      setSent(true);
      setTimeout(() => setSent(false), 3000);
    } catch (_) { }
    setSending(false);
  };

  const handlePrint = () => {
    const frame = document.getElementById("inv-frame");
    if (frame) {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    }
  };

  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

  return (
    <div onClick={onClose} className="invoice-modal-overlay">
      <div onClick={(e) => e.stopPropagation()} className="invoice-modal">
        <div className="invoice-modal-header">
          <div className="invoice-modal-title" style={{ color: primaryColor }}>
            📄 Invoice Preview
          </div>
          <div className="invoice-modal-actions">
            {sent && <span className="invoice-modal-sent-badge">✓ Sent!</span>}
            <button
              onClick={handleResend}
              disabled={sending}
              className="invoice-modal-resend-btn"
              style={{ background: `${primaryColor}15`, color: primaryColor, borderColor: `${primaryColor}35` }}
            >
              {sending ? "Sending…" : "📧 Resend Email"}
            </button>
            <button onClick={handlePrint} className="invoice-modal-print-btn" style={{ background: `linear-gradient(135deg, ${primaryColor}, ${primaryColor}dd)` }}>
              🖨 Print / PDF
            </button>
            <button onClick={onClose} className="invoice-modal-close-btn">×</button>
          </div>
        </div>
        <div className="invoice-modal-body">
          {loading ? (
            <div className="invoice-modal-loading">
              <div className="invoice-modal-loading-icon">⏳</div>
              <div>Loading invoice…</div>
            </div>
          ) : (
            <iframe id="inv-frame" srcDoc={html} className="invoice-modal-iframe" title="Invoice" />
          )}
        </div>
      </div>
    </div>
  );
};

// Elegant Invoice Card
const InvoiceCard = ({ invoice, onView }) => {
  const isRefunded = invoice.status === "refunded" || invoice.type === "refund";
  const isCancelled = invoice.status === "cancelled" || invoice.type === "cancellation";
  const type = isRefunded ? TYPE_CFG.refund : (isCancelled ? TYPE_CFG.cancellation : (TYPE_CFG[invoice.type] || TYPE_CFG.booking));
  const status = STATUS_CFG[invoice.status] || STATUS_CFG.issued;
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

  const sym = invoice.currency_symbol || "₹";
  const pos = invoice.currency_symbol_position || "before";
  const dec = invoice.currency_decimals ?? 2;
  const locale = invoice.number_format_locale || "en-IN";

  const f = (n) => {
    if (n == null) return "—";
    const formatted = new Intl.NumberFormat(locale, {
      minimumFractionDigits: dec,
      maximumFractionDigits: dec,
    }).format(parseFloat(n));
    return pos === "after" ? `${formatted} ${sym}` : `${sym} ${formatted}`;
  };

  const labels = invoice.fee_labels || {};
  const fees = [
    invoice.processing_fee > 0 && { label: labels.processing || "Processing", val: invoice.processing_fee },
    invoice.stamp_duty > 0 && { label: labels.stamp_duty || "Stamp Duty", val: invoice.stamp_duty },
    invoice.registration_fee > 0 && { label: labels.registration || "Reg Fee", val: invoice.registration_fee },
    invoice.maintenance_charge > 0 && { label: labels.maintenance || "Maintenance", val: invoice.maintenance_charge },
    invoice.custom_fee1 > 0 && { label: labels.custom1 || "Custom 1", val: invoice.custom_fee1 },
    invoice.custom_fee2 > 0 && { label: labels.custom2 || "Custom 2", val: invoice.custom_fee2 },
    invoice.tax_amount > 0 && { label: labels.tax || invoice.tax_label || "Tax", val: invoice.tax_amount },
  ].filter(Boolean);

  const displayAmount = isRefunded ? -Math.abs(parseFloat(invoice.amount_paid || 0)) : parseFloat(invoice.amount_paid || 0);
  const displayTotal = isRefunded ? -Math.abs(parseFloat(invoice.total_amount || 0)) : parseFloat(invoice.total_amount || 0);
  const displayBalance = isRefunded ? -Math.abs(parseFloat(invoice.balance_due || 0)) : parseFloat(invoice.balance_due || 0);

  return (
    <div
      onClick={() => onView(invoice.id)}
      className="invoice-card"
      style={{
        background: isRefunded ? "rgba(148,163,184,0.04)" : "var(--card-bg)",
        border: `1px solid ${isRefunded ? "rgba(148,163,184,0.2)" : "var(--card-border)"}`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = isRefunded ? "#94a3b860" : primaryColor + "40";
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = `0 8px 30px ${primaryColor}10`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = isRefunded ? "rgba(148,163,184,0.2)" : "var(--card-border)";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div className="invoice-card-header">
        <div className="invoice-card-info">
          <div className="invoice-card-badges">
            <span className="invoice-card-type-badge" style={{ background: type.bg, color: type.color, border: `1px solid ${type.color}33` }}>
              {type.icon} {type.label}
            </span>
            <span className="invoice-card-number" style={{ color: "var(--text-dark)" }}>#{invoice.invoice_number}</span>
            <span className="invoice-card-status-badge" style={{ color: status.color, background: `${status.color}10` }}>
              {status.label}
            </span>
          </div>

          <div className="invoice-card-details">
            🏠 Unit {invoice.plot_number}
            {invoice.plot_type && ` · ${invoice.plot_type}`}
            {invoice.area && ` · ${invoice.area} ${invoice.area_unit || ""}`}
            {invoice.project_name && ` · ${invoice.project_name}`}
          </div>

          {invoice.type === "milestone" && invoice.meta?.milestone_label && (
            <div className="invoice-card-milestone" style={{ color: "#22c55e" }}>💳 {invoice.meta.milestone_label}</div>
          )}

          <div className="invoice-card-meta">
            Booking #{invoice.booking_id} ·{" "}
            {new Date(invoice.issued_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
            {invoice.email_sent_at && (
              <span className="invoice-card-email-sent" style={{ color: "#22c55e" }}>
                ✉ Sent {new Date(invoice.email_sent_at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}
                {invoice.broker_copy_sent && " + broker copy"}
              </span>
            )}
          </div>

          {fees.length > 0 && (
            <div className="invoice-card-fees">
              {fees.map((fee, i) => (
                <span key={i} className="invoice-card-fee">{fee.label}: {f(fee.val)}</span>
              ))}
            </div>
          )}
        </div>

        <div className="invoice-card-amount">
          <div className="invoice-card-amount-label">
            {invoice.type === "milestone" ? "Received" : (isRefunded ? "Refunded Amount" : "Amount Paid")}
          </div>
          <div className="invoice-card-amount-value" style={{ color: isRefunded ? "#94a3b8" : primaryColor, fontSize: isRefunded ? "22px" : "26px" }}>
            {isRefunded ? `−${f(Math.abs(displayAmount))}` : f(displayAmount)}
          </div>
          {displayTotal > 0 && Math.abs(displayTotal) > Math.abs(displayAmount) && (
            <div className="invoice-card-total">of {f(Math.abs(displayTotal))}</div>
          )}
          {displayBalance !== 0 && !isRefunded && (
            displayBalance > 0 ? (
              <div className="invoice-card-due" style={{ color: "#f59e0b" }}>Due: {f(displayBalance)}</div>
            ) : (
              invoice.type !== "milestone" && (
                <div className="invoice-card-paid" style={{ color: "#22c55e" }}>✓ Fully Paid</div>
              )
            )
          )}
          {isRefunded && <div className="invoice-card-refunded" style={{ color: "#94a3b8" }}>✓ Amount Refunded</div>}
          {isCancelled && !isRefunded && <div className="invoice-card-cancelled" style={{ color: "#ef4444" }}>✕ Invoice Cancelled</div>}
        </div>
      </div>

      <div className="invoice-card-footer" style={{ color: primaryColor }}>🔍 Tap to view & print invoice →</div>
    </div>
  );
};

// Elegant Stat Card for Invoices
const InvoiceStatCard = ({ icon, label, value, color }) => (
  <div className="invoice-stat-card" onMouseEnter={(e) => { e.currentTarget.style.borderColor = color; e.currentTarget.style.transform = "translateY(-2px)"; }} onMouseLeave={(e) => { e.currentTarget.style.borderColor = "var(--card-border)"; e.currentTarget.style.transform = "translateY(0)"; }}>
    <div className="invoice-stat-card-icon">{icon}</div>
    <div className="invoice-stat-card-value" style={{ color }}>{value}</div>
    <div className="invoice-stat-card-label">{label}</div>
  </div>
);

export default function InvoicesTab({ user, fmt, tenant }) {
  const [invoices, setInvoices] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [previewId, setPreviewId] = useState(null);
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim() || "#c9a96e";

  const fetchInvoices = useCallback(async () => {
    if (!tenant || !user?.token) return;
    
    setLoading(true);
    try {
      const data = await apiJson(tenant, `/invoices`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
          Accept: "application/json",
        },
      });
      
      console.log('API Response:', data); // Debug log
      
      // Handle the response format - the API returns { success: true, invoices: [...], stats: {...} }
      if (data.success && Array.isArray(data.invoices)) {
        setInvoices(data.invoices);
        setStats(data.stats);
      } else if (Array.isArray(data)) {
        // Fallback for older API format
        setInvoices(data);
        setStats(null);
      } else {
        console.error('Unexpected API response format:', data);
        setInvoices([]);
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      setInvoices([]);
    }
    setLoading(false);
  }, [tenant, user?.token]);

  useEffect(() => {
    if (user?.token && tenant) {
      fetchInvoices();
    }
  }, [fetchInvoices, user?.token, tenant]);

  if (!user) return null;

  // Filter invoices
  const filtered = filter === "all" 
    ? invoices 
    : invoices.filter((i) => i.type === filter);

  // Use stats from API if available, otherwise calculate locally
  const totalInvoices = stats?.total_invoices || invoices.length;
  const totalPaid = stats?.total_paid || 0;
  const totalRefunded = stats?.total_refunded || 0;
  const totalDue = stats?.total_due || 0;

  const sym = invoices[0]?.currency_symbol || "₹";
  const locale = invoices[0]?.number_format_locale || "en-IN";
  const dec = invoices[0]?.currency_decimals ?? 2;
  
  const fStat = (n) => {
    if (n == null) return "₹0.00";
    return sym + " " + new Intl.NumberFormat(locale, {
      minimumFractionDigits: dec,
      maximumFractionDigits: dec,
    }).format(n);
  };

  if (loading) {
    return (
      <div className="invoices-loading">
        <div className="invoices-loading-icon">⏳</div>
        <div>Loading invoices…</div>
      </div>
    );
  }

  return (
    <div className="invoices-tab">
      {previewId && (
        <InvoicePreviewModal
          invoiceId={previewId}
          token={user.token}
          onClose={() => setPreviewId(null)}
          tenant={tenant}
        />
      )}

      {invoices.length > 0 && (
        <div className="invoices-stats">
          <InvoiceStatCard label="Total Invoices" value={totalInvoices} icon="📄" color={primaryColor} />
          <InvoiceStatCard label="Total Paid" value={fStat(totalPaid)} icon="💰" color="#22c55e" />
          {totalRefunded > 0 && (
            <InvoiceStatCard label="Refunded Amount" value={fStat(totalRefunded)} icon="↺" color="#94a3b8" />
          )}
          <InvoiceStatCard label="Balance Due" value={fStat(totalDue)} icon="⏳" color={totalDue > 0 ? "#f59e0b" : "#22c55e"} />
        </div>
      )}

      <div className="invoices-filters">
        {[
          ["all", "All"],
          ["booking", "Tax Invoices"],
          ["milestone", "Receipts"],
          ["refund", "Refund Notes"],
          ["cancellation", "Cancellations"],
        ].map(([val, label]) => {
          const count = val === "all" 
            ? invoices.length 
            : invoices.filter(i => i.type === val).length;
          return (
            <button
              key={val}
              onClick={() => setFilter(val)}
              className={`invoices-filter-btn ${filter === val ? 'active' : ''}`}
              style={{
                background: filter === val ? `${primaryColor}12` : "transparent",
                color: filter === val ? primaryColor : "var(--text-muted)",
                border: filter === val ? `1px solid ${primaryColor}30` : "1px solid transparent",
              }}
            >
              {label}
              {count > 0 && (
                <span className="invoices-filter-count" style={{
                  background: filter === val ? `${primaryColor}20` : "var(--page-bg)",
                  color: filter === val ? primaryColor : "var(--text-muted)",
                }}>
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {filtered.length === 0 ? (
        <div className="invoices-empty">
          <div className="invoices-empty-icon">📄</div>
          <div className="invoices-empty-title">No invoices yet</div>
          <div className="invoices-empty-text">Invoices are auto-generated when a booking is confirmed and for each milestone payment.</div>
        </div>
      ) : (
        <div className="invoices-list">
          {filtered.map((inv) => (
            <InvoiceCard key={inv.id} invoice={inv} onView={setPreviewId} />
          ))}
        </div>
      )}

      <style>{`
        .invoice-modal-overlay {
          position: fixed;
          inset: 0;
          z-index: 2000;
          background: rgba(0,0,0,0.8);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        .invoice-modal {
          background: #fff;         
          width: 100%;
          max-width: 900px;
          height: 90vh;
          display: flex;
          flex-direction: column;
          box-shadow: 0 32px 80px rgba(0,0,0,0.3);
          overflow: hidden;
        }
        .invoice-modal-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 24px;
          background: #1a1a2e;
          flex-shrink: 0;
        }
        .invoice-modal-title {
          font-size: 15px;
          font-weight: 700;
        }
        .invoice-modal-actions {
          display: flex;
          gap: 12px;
          align-items: center;
        }
        .invoice-modal-sent-badge {
          font-size: 12px;
          color: #22c55e;
          font-weight: 600;
          background: #22c55e15;
          padding: 4px 12px;         
        }
        .invoice-modal-resend-btn {
          padding: 8px 18px;          
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          border: 1px solid;
          transition: all 0.2s ease;
        }
        .invoice-modal-resend-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .invoice-modal-print-btn {
          padding: 8px 18px;          
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          color: #fff;
          border: none;
          transition: all 0.2s ease;
        }
        .invoice-modal-print-btn:hover {
          transform: translateY(-1px);
        }
        .invoice-modal-close-btn {
          background: rgba(255,255,255,0.1);
          border: 1px solid rgba(255,255,255,0.15);
          color: #fff;
          width: 36px;
          height: 36px;        
          cursor: pointer;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
        }
        .invoice-modal-close-btn:hover {
          background: rgba(255,255,255,0.2);
        }
        .invoice-modal-body {
          flex: 1;
          overflow: hidden;
          background: #f4f4f4;
        }
        .invoice-modal-loading {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          color: #64748b;
          flex-direction: column;
          gap: 16px;
        }
        .invoice-modal-loading-icon {
          font-size: 48px;
        }
        .invoice-modal-iframe {
          width: 100%;
          height: 100%;
          border: none;
        }
        .invoices-loading {
          text-align: center;
          padding: 80px 0;
          color: var(--text-muted);
        }
        .invoices-loading-icon {
          font-size: 48px;
          margin-bottom: 16px;
        }
        .invoice-stat-card {
          background: var(--card-bg);
          border: 1px solid var(--card-border);          
          padding: 16px 18px;
          transition: all 0.2s ease;
        }
        .invoice-stat-card-icon {
          font-size: 28px;
          margin-bottom: 8px;
        }
        .invoice-stat-card-value {
          font-size: 22px;
          font-weight: 800;
        }
        .invoice-stat-card-label {
          font-size: 12px;
          color: var(--text-muted);
          margin-top: 4px;
        }
        .invoices-stats {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 12px;
          margin-bottom: 28px;
        }
        .invoices-filters {
          display: flex;
          gap: 6px;
          margin-bottom: 24px;
          background: var(--card-bg);
          padding: 6px;          
          border: 1px solid var(--card-border);
          width: fit-content;
          flex-wrap: wrap;
        }
        .invoices-filter-btn {
          padding: 8px 20px;          
          cursor: pointer;
          font-size: 13px;
          font-weight: 600;
          transition: all 0.2s ease;
          font-family: var(--font-body, inherit);
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .invoices-filter-count {
          padding: 2px 8px;         
          font-size: 11px;
          font-weight: 700;
          border: 1px solid var(--card-border);
        }
        .invoices-empty {
          text-align: center;
          padding: 80px 0;
        }
        .invoices-empty-icon {
          font-size: 64px;
          margin-bottom: 16px;
        }
        .invoices-empty-title {
          font-size: 18px;
          font-weight: 700;
          color: var(--text-dark);
          margin-bottom: 10px;
          font-family: var(--font-heading, inherit);
        }
        .invoices-empty-text {
          font-size: 14px;
          color: var(--text-muted);
        }
        .invoices-list {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }
        .invoice-card {        
          padding: 20px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.2, 0.9, 0.4, 1.1);
        }
        .invoice-card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 16px;
          flex-wrap: wrap;
        }
        .invoice-card-info {
          flex: 1;
        }
        .invoice-card-badges {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
          margin-bottom: 10px;
        }
        .invoice-card-type-badge {
          padding: 4px 12px;          
          font-size: 11px;
          font-weight: 700;
        }
        .invoice-card-number {
          font-size: 16px;
          font-weight: 800;
          font-family: var(--font-heading, inherit);
        }
        .invoice-card-status-badge {
          font-size: 11px;
          font-weight: 700;
          padding: 3px 10px;        
        }
        .invoice-card-details {
          font-size: 13px;
          color: var(--text-muted);
          margin-bottom: 6px;
        }
        .invoice-card-milestone {
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 4px;
        }
        .invoice-card-meta {
          font-size: 11px;
          color: var(--text-muted);
          margin-top: 6px;
        }
        .invoice-card-email-sent {
          margin-left: 12px;
        }
        .invoice-card-fees {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin-top: 12px;
        }
        .invoice-card-fee {
          font-size: 11px;
          font-weight: 600;
          padding: 3px 10px;         
          background: var(--page-bg);
          color: var(--text-muted);
          border: 1px solid var(--card-border);
        }
        .invoice-card-amount {
          text-align: right;
          flex-shrink: 0;
        }
        .invoice-card-amount-label {
          font-size: 11px;
          color: var(--text-muted);
          margin-bottom: 4px;
        }
        .invoice-card-amount-value {
          font-weight: 800;
          font-family: var(--font-heading, inherit);
        }
        .invoice-card-total {
          font-size: 12px;
          color: var(--text-muted);
          margin-top: 2px;
        }
        .invoice-card-due {
          font-size: 13px;
          margin-top: 6px;
          font-weight: 700;
        }
        .invoice-card-paid {
          font-size: 12px;
          margin-top: 6px;
          font-weight: 600;
        }
        .invoice-card-refunded {
          font-size: 12px;
          margin-top: 6px;
          font-weight: 600;
        }
        .invoice-card-cancelled {
          font-size: 12px;
          margin-top: 6px;
          font-weight: 600;
        }
        .invoice-card-footer {
          margin-top: 16px;
          font-size: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 6px;
        }
        @media (max-width: 768px) {
          .invoices-stats {
            grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          }
          .invoice-card-amount-value {
            font-size: 20px;
          }
          .invoice-card-header {
            flex-direction: column;
          }
          .invoice-card-amount {
            text-align: left;
          }
        }
      `}</style>
    </div>
  );
}